import { Component, OnInit, AfterViewInit, ViewChild, HostListener, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { Router, RouterModule, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Actions, TableColumn } from '@app/shared/table/TableColumn';
import { MatPaginator } from '@angular/material/paginator';
import { UtilService } from '@app/shared/services/util.service';
import { ApiService } from '@app/shared/services/api.service';
import { environment } from "../../environments/environment"
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GetAllService } from '@app/shared/table/getAll.service';
import Quill from 'quill';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';

@Component({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, RouterModule, TicketDetailComponent],
    selector: 'app-table-view',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.css']
})
export class TicketComponent implements OnInit, AfterViewInit {
  // Loading state
  isLoading: boolean = false;
  isCreatingTicket: boolean = false;
  isSubmittingTicket: boolean = false;
  currentCcInput: string = '';
  ccEmailError: string = '';
  isCcTouched: boolean = false;

  get isCcPending(): boolean {
    return !!this.currentCcInput && this.currentCcInput.trim().length > 0;
  }

  // File Upload State
  selectedFiles: File[] = [];
  isDragging: boolean = false;
  uploadedAttachments: any[] = [];
  currentTicketAttachments: any[] = [];

  // Table Configuration
  tableColumns: TableColumn[] = [];
  tableActions: Actions[] = [];
  filterAttributes: any[] = [];
  allCustomerCountsData: any[] = [];
  originalDataSource: any[] = [];

  // Form State
  ticket: any = {
    subject: '',
    description: '',
    priority: '',
    status: '',
    source: 2,
    org_id: null,
    cc_emails: []
  };

  // CC Emails
  ccEmails: string[] = [];

  // Organization List for Dropdown
  orgList: any[] = [];
  filteredOrgList: any[] = [];
  orgName: string | null = null;
  showOrganizationColumn: boolean = false;

  // Organization Selection Modal State
  showOrgSelectModal: boolean = false;
  selectedOrgId: number | null = null;
  selectedOrgName: string | null = null;
  orgSearchQuery: string = '';

  // Organization Edit Modal State
  showOrgEditModal: boolean = false;
  currentEditTicket: any = null;
  selectedEditOrgId: number | null = null;
  selectedEditOrgName: string | null = null;
  editOrgSearchQuery: string = '';
  isUpdatingOrg: boolean = false;

  // View Ticket Properties
  viewTicketData: any = null;
  viewTicketId: number | null = null;
  viewTicketSummary: string | null = null;
  viewTicketCreatedAt: string | null = null;
  viewTicketPriority: string | null = null;
  viewTicketDescription: SafeHtml | null = null;
  viewTicketAttachments: any[] = [];
  viewTicketType: string | null = null;
  viewTicketStatus: string | null = null;
  viewTicketRequesterEmail: string | null = null;

  // Edit Mode Properties
  isEditingTicket: boolean = false;
  currentTicketId: number | null = null;
  orgId: number | null = null;
  EditOrgId : any | null = null;
  editOrgName : string = '';
  // Row Actions
  rowActionList: Actions[] = [
    {
      iconName: 'eye',
      iconTooltip: 'View Ticket',
      name: 'view_ticket'
    },
    {
      iconName: 'edit',
      iconTooltip: 'Modify Ticket',
      name: 'edit',
    }
  ];
  externalVideoUrl: string = '';

  // Filter Properties
  @ViewChild('filterBox') filterBox: ElementRef;
  @ViewChild('filterButton') filterButton: ElementRef;
  showfilterdivbox = false;
  filterCount: number = 0;
  filters = ["Status", "Priority", "Created Date", "All Text"];
  selectedFilter: string | null = "Status";
  searchQuery = "";
  selectedOption = "";
  selectedFilters: { key: string; value: string }[] = [];
  filterOptions: { [key: string]: string[] } = {
    "Status": ["Open", "Pending", "Resolved", "Closed"],
    "Priority": ["Low", "Medium", "High", "Urgent"]
  };
  selectedOptions: { [key: string]: any } = {
    "Status": [],
    "Priority": []
  };

  // Date Filter Properties
  dateFilterType: string = 'exact';
  exactDate: string = '';
  startDate: string = '';
  endDate: string = '';
  dateFilterActive: boolean = false;

  quillEditor: Quill | null = null;

  // Freshdesk Super Admin UI State
  isSuperAdmin: boolean = false;
  selectedTicket: any = null;
  ticketListSearchQuery: string = '';
  
  // Pagination State
  currentPage: number = 1;
  pageSize: number = 10;

  // Sorting State (Matching Freshdesk screenshot)
  sortByField: 'created_at' | 'due_by' | 'updated_at' | 'priority' | 'status' = 'created_at';
  sortOrder: 'asc' | 'desc' = 'desc';
  showSortDropdown: boolean = false;
  sortFieldLabels: { [key: string]: string } = {
    'created_at': 'Date created',
    'due_by': 'Due by time',
    'updated_at': 'Last modified',
    'priority': 'Priority',
    'status': 'Status'
  };

  get currentSortLabel(): string {
    return this.sortFieldLabels[this.sortByField] || 'Date created';
  }

  // 2-Column Filter Popup State (matching Certiplate table filter)
  showFilterPopup: boolean = false;
  selectedFilterTab: string = 'Priority';
  filterTabs: string[] = ['Priority', 'Status', 'Created Date', 'Organization'];
  
  // Row Quick-Update Dropdown States
  activePriorityDropdownTicketId: number | null = null;
  activeStatusDropdownTicketId: number | null = null;
  
  // Applied filters state
  appliedFilters = {
    subjectOption: 'contains' as 'is' | 'contains',
    subjectValue: '',
    priorities: [] as string[],
    statuses: [] as string[],
    descriptionOption: 'contains' as 'is' | 'contains',
    descriptionValue: '',
    createdDateOption: 'is' as 'is' | 'between',
    createdDateStart: '',
    createdDateEnd: '',
    requesterEmailOption: 'contains' as 'is' | 'contains',
    requesterEmailValue: '',
    orgName: ''
  };

  // Temp working copy for open filter popup
  tempFilters = {
    subjectOption: 'contains' as 'is' | 'contains',
    subjectValue: '',
    priorities: [] as string[],
    statuses: [] as string[],
    descriptionOption: 'contains' as 'is' | 'contains',
    descriptionValue: '',
    createdDateOption: 'is' as 'is' | 'between',
    createdDateStart: '',
    createdDateEnd: '',
    requesterEmailOption: 'contains' as 'is' | 'contains',
    requesterEmailValue: '',
    orgName: ''
  };

  replyMode: 'reply' | 'note' = 'reply';
  ticketReplyText: string = '';
  isSendingReply: boolean = false;
  ticketConversations: any[] = [];
  isLoadingConversations: boolean = false;
  selectedTicketStatus: number = 2;
  selectedTicketPriority: number = 1;
  selectedTicketType: string = '--';
  isUpdatingProperties: boolean = false;

  // Multi-select and Bulk Actions State
  selectedTicketIds: Set<number> = new Set<number>();
  showBulkAssignModal: boolean = false;
  showDeleteConfirmModal: boolean = false;
  bulkAssigneeEmail: string = '';
  isBulkUpdating: boolean = false;

  // Table Data Source
  tableDataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private util: UtilService,
    private toastr: ToastrService,
    private getAllService: GetAllService,
    private api: ApiService
  ) {
  }
  ngOnInit(): void {
    const token = localStorage.getItem('JwtToken');
    if (!token) {
      const returnUrl = (this.route.url && this.route.url !== '/' && !this.route.url.includes('/account/')) ? this.route.url : (window.location.pathname + window.location.search);
      this.route.navigate(['/account/login'], { queryParams: { returnUrl } });
      return;
    }

    // Check role from localStorage
    this.isSuperAdmin = this.isSuperAdminUser();
    this.showOrganizationColumn = this.isSuperAdmin;

    this.initializeTableColumns();
    this.initializeTableActions();
    this.initializeFilterAttributes();

    this.extractAndStoreOrgDetails();
    this.fetchTickets();

    this.activatedRoute.params.subscribe((params) => {
      const id = params['id'];
      if (id) {
        this.loadAndSelectTicketById(+id);
      } else {
        this.selectedTicket = null;
        this.cdr.detectChanges();
      }
    });
  }

  private extractAndStoreOrgId(): void {
    const encryptedOrgId = localStorage.getItem('OrgId');

    if (!encryptedOrgId) {
      console.warn('OrgId not found in localStorage');
      return;
    }

    try {
      const decrypted = this.util.decrypt(encryptedOrgId);

      if (decrypted) {

        this.orgId = parseInt(decrypted, 10);

        if (!isNaN(this.orgId)) {
        } else {
        }
      }
    } catch (error) {
    }
  }


  ngAfterViewInit(): void {
    this.tableDataSource.sort = this.sort;
    this.tableDataSource.paginator = this.paginator;
    this.cdr.detectChanges();
  }

  // Initialize Quill Editor
private initializeQuillEditor(): void {
  try {
    if (!this.isCreatingTicket) {
      console.log('Modal closed before Quill initialization, skipping');
      return;
    }

    this.destroyQuillEditor();

    setTimeout(() => {
      if (!this.isCreatingTicket) {
        console.log('Modal closed during Quill cleanup delay, skipping');
        return;
      }

      const editorElement = document.querySelector('#quill-editor') as HTMLElement;
      if (!editorElement) {
        console.warn('Quill editor element not found in DOM');
        return;
      }

      // Clear editor
      editorElement.innerHTML = '';
      while (editorElement.firstChild) {
        editorElement.removeChild(editorElement.firstChild);
      }

      try {
        this.quillEditor = new Quill('#quill-editor', {
          theme: 'snow',
          placeholder: 'Enter description...',
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote'],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['image'],
            ]
          }
        });

        console.log('Quill editor initialized successfully');
        
        if (this.ticket && this.ticket.description) {
          setTimeout(() => {
            if (this.quillEditor) {
              const desc = this.ticket.description;
              if (typeof desc === 'string' && desc.trim()) {
                try {
                  // Clear any existing content
                  this.quillEditor.setText('');
                  
                  // IMPORTANT: Use setContents() for Delta format or dangerouslyPasteHTML for HTML
                  // First, check if it's valid HTML with lists
                  if (desc.includes('<ol>') || desc.includes('<ul>')) {
                    // This is HTML with lists, use dangerouslyPasteHTML
                    console.log('Setting HTML content with lists');
                    this.quillEditor.clipboard.dangerouslyPasteHTML(0, desc);
                  } else {
                    // Try to parse as Delta
                    try {
                      const delta = JSON.parse(desc);
                      if (delta && delta.ops) {
                        this.quillEditor.setContents(delta);
                      } else {
                        this.quillEditor.clipboard.dangerouslyPasteHTML(0, desc);
                      }
                    } catch {
                      // If not Delta, use as plain HTML
                      this.quillEditor.clipboard.dangerouslyPasteHTML(0, desc);
                    }
                  }
                  
                  console.log('Quill content set successfully');
                } catch (pasteError) {
                  console.error('Error pasting HTML into Quill:', pasteError);
                  // Fallback to plain text
                  this.quillEditor.setText(desc);
                }
              }
            }
          }, 100);
        }

        // Text change handler
        this.quillEditor.on('text-change', () => {
          if (this.ticket && this.quillEditor) {
            // Get the HTML content
            this.ticket.description = this.quillEditor.root.innerHTML;
            this.cdr.detectChanges();
          }
        });

        // Image upload handler
        const toolbar: any = this.quillEditor.getModule('toolbar');
        if (toolbar) {
          toolbar.addHandler('image', () => this.handleImageUpload());
        }

      } catch (e) {
        console.error('Error creating Quill instance:', e);
      }
    }, 150);
  } catch (e) {
    console.error('Error in initializeQuillEditor:', e);
  }
}

  // Destroy Quill Editor
  private destroyQuillEditor(): void {
    try {
      if (this.quillEditor) {
        console.log('Destroying Quill editor instance...');
        this.quillEditor = null;
      }

      const editorElement = document.querySelector('#quill-editor') as HTMLElement;
      if (editorElement) {
        console.log('Quill editor element found, clearing DOM...');
        editorElement.innerHTML = '';

        while (editorElement.firstChild) {
          editorElement.removeChild(editorElement.firstChild);
        }

        const toolbarElement = document.querySelector('.ql-toolbar');
        if (toolbarElement) {
          console.log('Removing toolbar element...');
          toolbarElement.remove();
        }

        const style = editorElement.getAttribute('style');
        editorElement.setAttribute('id', 'quill-editor');
        if (style) {
          editorElement.setAttribute('style', style);
        }
      }

      console.log('Quill editor instance destroyed');
    } catch (e) {
      console.error('Error in destroyQuillEditor:', e);
    }
  }

  // Handle Image Upload (supports images, PDFs, videos, Excel files)
  private pendingVideoFiles: File[] = [];
private pendingFiles: { file: File; isVideo: boolean; isPdf: boolean }[] = [];

private handleImageUpload(): void {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*,video/*,.mp4,.avi,.mov,.webm,.mkv,.pdf,.doc,.docx,.xls,.xlsx');
  input.click();

  input.onchange = () => {
    const file: File | undefined = input.files?.[0];
    if (!file) return;

    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');
    const isPdf = file.type === 'application/pdf';
    const isDocument = file.type.includes('document') || 
                      file.name.endsWith('.doc') || 
                      file.name.endsWith('.docx');
    const isExcel = file.type.includes('spreadsheet') || 
                   file.name.endsWith('.xls') || 
                   file.name.endsWith('.xlsx');
    
    // ✅ 1GB size restriction check - IMMEDIATELY when file is selected
    const maxSizeGB = 1;
    const maxSizeBytes = maxSizeGB * 1024 * 1024 * 1024;
    
    if (file.size > maxSizeBytes) {
      this.toastr.error(`File "${file.name}" is too large. Maximum allowed size is ${maxSizeGB}GB.`);
      return; // Don't proceed with upload
    }
    
    if (!isImage && !isVideo && !isPdf && !isDocument && !isExcel) {
      this.toastr.error('Only image, video, PDF, Word, and Excel files are supported.');
      return;
    }

    if (isVideo) {
      const allowedTypes = ['video/mp4', 'video/avi', 'video/mov', 'video/webm', 'video/mkv'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('This video format is not allowed. Allowed: mp4, avi, mov, webm, mkv.');
        return;
      }
    }

    if (this.quillEditor) {
      const range = this.quillEditor.getSelection();
      
      if (isImage) {
        // For images, check if it's too large for inline display
        const maxImageSizeForPreview = 10 * 1024 * 1024; // 10MB for inline images
        if (file.size > maxImageSizeForPreview) {
          this.toastr.warning(`Image "${file.name}" is large (${this.formatFileSize(file.size)}). It will be added as an attachment instead of inline preview.`);
          // Add as text placeholder instead of inline image
          const imageText = `[Image: ${file.name} - ${this.formatFileSize(file.size)}]`;
          this.quillEditor!.insertText(range ? range.index : 0, imageText + '\n', 'italic', true);
          this.quillEditor!.setSelection((range ? range.index : 0) + imageText.length + 1, 0);
          this.pendingFiles.push({ file, isVideo: false, isPdf: false });
        } else {
          // For small images, embed directly
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.quillEditor!.insertEmbed(range ? range.index : 0, 'image', e.target.result, 'user');
            this.quillEditor!.setSelection((range ? range.index : 0) + 1, 0);
          };
          reader.readAsDataURL(file);
        }
      } else if (isVideo) {
        // For videos, show placeholder text
        const videoText = `[Video: ${file.name} - ${this.formatFileSize(file.size)}]`;
        this.quillEditor!.insertText(range ? range.index : 0, videoText + '\n', 'italic', true);
        this.quillEditor!.setSelection((range ? range.index : 0) + videoText.length + 1, 0);
        this.pendingFiles.push({ file, isVideo: true, isPdf: false });
      } else if (isPdf || isDocument || isExcel) {
        // For PDFs and documents, show placeholder text
        const docType = isPdf ? 'PDF' : (isDocument ? 'Word Document' : 'Excel File');
        const docText = `[${docType}: ${file.name} - ${this.formatFileSize(file.size)}]`;
        this.quillEditor!.insertText(range ? range.index : 0, docText + '\n', 'bold', true);
        this.quillEditor!.setSelection((range ? range.index : 0) + docText.length + 1, 0);
        this.pendingFiles.push({ file, isVideo: false, isPdf: isPdf });
      }
    }
  };
}
// Helper method to format file size
private formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

  // Parse description content from Delta format
  private parseDescription(description: string): any {
    try {
      if (typeof description === 'string') {
        try {
          return JSON.parse(description);
        } catch {
          // If plain text, convert to Delta
          return { ops: [{ insert: description }] };
        }
      }
      return description;
    } catch (error) {
      console.error('Error parsing description:', error);
      return { ops: [{ insert: '' }] };
    }
  }

  // Get Quill editor content as HTML with preserved formatting
  private getQuillEditorContent(): string {
    if (this.quillEditor) {
      let html = this.quillEditor.root.innerHTML;
      
      // Convert Quill's indentation classes to inline styles
      // Handle paragraphs, divs, and list items with indentation
      html = html.replace(/class="ql-indent-(\d)"(?=[^>]*>)/g, (match, level) => {
        const indentLevel = parseInt(level);
        const marginLeft = (indentLevel * 1.5) + 'em'; // 1.5em per indent level
        return `style="margin-left: ${marginLeft};"`;
      });
      
      // Also handle cases where there are multiple classes
      html = html.replace(/class="([^"]*\s)?ql-indent-(\d)(\s[^"]*)?"/g, (match, before, level, after) => {
        const indentLevel = parseInt(level);
        const marginLeft = (indentLevel * 1.5) + 'em';
        // If there are other classes, keep them, otherwise just use the style
        const otherClasses = ((before || '') + (after || '')).trim();
        if (otherClasses) {
          return `class="${otherClasses}" style="margin-left: ${marginLeft};"`;
        }
        return `style="margin-left: ${marginLeft};"`;
      });

      // Convert Quill's text alignment classes to inline styles
      // Handle ql-align-center, ql-align-right, ql-align-justify
      html = html.replace(/class="ql-align-(center|right|justify|left)"(?=[^>]*>)/g, (match, alignment) => {
        return `style="text-align: ${alignment};"`;
      });

      // Also handle cases where alignment classes are mixed with other classes
      html = html.replace(/class="([^"]*\s)?ql-align-(center|right|justify|left)(\s[^"]*)?"/g, (match, before, alignment, after) => {
        const otherClasses = ((before || '') + (after || '')).trim();
        if (otherClasses) {
          return `class="${otherClasses}" style="text-align: ${alignment};"`;
        }
        return `style="text-align: ${alignment};"`;
      });
      
      return html;
    }
    return this.ticket.description;
  }

  // Get Quill editor content as Delta
  private getQuillEditorDelta(): any {
    if (this.quillEditor) {
      return this.quillEditor.getContents();
    }
    return { ops: [{ insert: this.ticket.description }] };
  }

private extractAndStoreOrgDetails(): void {
  const encryptedOrgId = localStorage.getItem('OrgId');
  const userOrgListData = localStorage.getItem('userOrgList');

  // Debug logging
  console.log('Extracting org details...');
  console.log('Encrypted OrgId exists:', !!encryptedOrgId);
  console.log('userOrgList exists:', !!userOrgListData);
  
  if (userOrgListData) {
    console.log('userOrgList first 100 chars:', userOrgListData.substring(0, 100));
  }

  // Handle OrgId
  if (encryptedOrgId) {
    try {
      // Try to decrypt first
      const decrypted = this.util.decrypt(encryptedOrgId);
      if (decrypted) {
        this.orgId = parseInt(decrypted, 10);
        if (isNaN(this.orgId)) {
          console.warn('Decrypted OrgId is not a number:', decrypted);
          // Try to parse directly if decryption failed but data might be plain
          try {
            this.orgId = parseInt(encryptedOrgId, 10);
          } catch (e) {
            console.error('Cannot parse OrgId:', e);
          }
        }
      } else {
        // If decryption returns null/empty, try to parse as plain number
        try {
          this.orgId = parseInt(encryptedOrgId, 10);
        } catch (e) {
          console.error('Cannot parse OrgId as number:', e);
        }
      }
    } catch (error) {
      console.warn('Error decrypting OrgId, trying to parse as plain:', error);
      try {
        this.orgId = parseInt(encryptedOrgId, 10);
      } catch (e) {
        console.error('Cannot parse OrgId:', e);
      }
    }
  }

  // Handle userOrgList
  if (userOrgListData) {
    try {
      // First, check if it's already valid JSON (not encrypted)
      let parsedData = null;
      
      try {
        // Try to parse directly as JSON
        parsedData = JSON.parse(userOrgListData);
        console.log('Successfully parsed userOrgList as direct JSON');
      } catch (jsonError) {
        console.log('Not direct JSON, trying decryption...');
        
        // If not JSON, try to decrypt
        try {
          const decrypted = this.util.decrypt(userOrgListData);
          if (decrypted) {
            // Try to parse decrypted data as JSON
            parsedData = JSON.parse(decrypted);
            console.log('Successfully decrypted and parsed userOrgList');
          }
        } catch (decryptError) {
          console.warn('Error decrypting userOrgList:', decryptError);
          
          // If decryption also fails, try to see if it's malformed JSON
          // Remove any trailing commas or fix common JSON issues
          const cleaned = this.cleanJsonString(userOrgListData);
          try {
            parsedData = JSON.parse(cleaned);
            console.log('Successfully parsed cleaned userOrgList');
          } catch (cleanError) {
            console.error('Could not parse userOrgList in any format:', cleanError);
          }
        }
      }
      
      if (parsedData && Array.isArray(parsedData)) {
        this.orgList = parsedData;
        console.log(`Loaded ${this.orgList.length} organizations`);
        
        // Find current organization if orgId is available
        if (this.orgId) {
          const foundOrg = this.orgList.find((org: any) => {
            // Check various possible id fields
            const orgIdFromList = org.org_id ?? org.id ?? org.organization_id;
            return orgIdFromList == this.orgId || 
                   String(orgIdFromList) === String(this.orgId);
          });
          
          if (foundOrg) {
            this.orgName = foundOrg.org_name || foundOrg.name || foundOrg.organization_name || null;
            console.log('Found current org:', this.orgName);
          }
        }
      }
    } catch (error) {
      console.error('Error processing userOrgList:', error);
    }
  }
}

// Add this helper method to clean JSON strings
private cleanJsonString(str: string): string {
  if (!str) return str;
  
  // Remove trailing commas before closing braces/brackets
  let cleaned = str.replace(/,\s*}/g, '}');
  cleaned = cleaned.replace(/,\s*]/g, ']');
  
  // Fix single quotes to double quotes if needed
  if (cleaned.includes("'") && !cleaned.includes('"')) {
    cleaned = cleaned.replace(/'/g, '"');
  }
  
  return cleaned;
}

  private fetchOrgNameFromUserOrgList(): void {
    try {

      const encryptedUserOrgList = localStorage.getItem('userOrgList');

      if (!encryptedUserOrgList) {
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          console.log(`Key ${i}: ${key}`);
        }
        return;
      }

      // Decrypt userOrgList
      const decryptedOrgList = this.util.decrypt(encryptedUserOrgList);

      if (!decryptedOrgList) {
        return;
      }

      // Check if it's JSON
      const isJson = this.util.isJson(decryptedOrgList);

      if (isJson) {
        try {
          this.orgList = JSON.parse(decryptedOrgList);
          if (Array.isArray(this.orgList)) {

            if (this.orgList.length > 0) {

              // Try to find organization by ID in multiple ways
              let foundOrg = null;

              // Method 1: Direct match
              foundOrg = this.orgList.find((org: any) => {
                // Try different possible id field names
                if (org.id && (org.id === this.orgId || parseInt(org.id) === this.orgId)) {
                  return true;
                }
                if (org.org_id && (org.org_id === this.orgId || parseInt(org.org_id) === this.orgId)) {
                  return true;
                }
                if (org.organization_id && (org.organization_id === this.orgId || parseInt(org.organization_id) === this.orgId)) {
                  return true;
                }
                return false;
              });

              // Method 2: If not found, try string comparison
              if (!foundOrg) {
                console.log('Trying string comparison...');
                foundOrg = this.orgList.find((org: any) => {
                  const orgIdStr = this.orgId?.toString();
                  return (
                    org.id?.toString() === orgIdStr ||
                    org.org_id?.toString() === orgIdStr ||
                    org.organization_id?.toString() === orgIdStr
                  );
                });
              }

              if (foundOrg) {

                // Try different possible name fields
                this.orgName =
                  foundOrg.org_name ||
                  foundOrg.name ||
                  foundOrg.organization_name ||
                  foundOrg.orgName ||
                  foundOrg.OrgName ||
                  foundOrg.display_name ||
                  foundOrg.organizationName ||
                  'Unknown Organization';


                // Store in localStorage for reference
                localStorage.setItem('current_org_name', this.orgName);
                localStorage.setItem('current_org_id', this.orgId?.toString() || '');

              } else {
                this.orgList.forEach((org: any, index: number) => {
                  console.log(`   [${index}] ID fields:`, {
                    id: org.id,
                    org_id: org.org_id,
                    organization_id: org.organization_id,
                    name: org.name || org.org_name
                  });
                });

                // Try to find any organization that might match
                const allOrgs = this.orgList.map((org: any) => ({
                  id: org.id,
                  org_id: org.org_id,
                  organization_id: org.organization_id,
                  name: org.name || org.org_name || 'No Name'
                }));
              }
            } 
          } else {
          }
        } catch (parseError) {
        }
      }
    } catch (error) {
      console.error('❌ Error in fetchOrgNameFromUserOrgList:', error);
    }
  }

  private getOrgNameFromUserOrgList(orgId: string): string | null {
    try {
      if (!this.orgList || this.orgList.length === 0) {
        const userOrgListRaw = localStorage.getItem('userOrgList');
        if (userOrgListRaw) {
          let tempOrgList = null;
          // Try direct JSON parse first
          try {
            if (this.util.isJson(userOrgListRaw)) {
              tempOrgList = JSON.parse(userOrgListRaw);
            } else {
              // Try decrypt then parse
              const decrypted = this.util.decrypt(userOrgListRaw);
              if (decrypted && this.util.isJson(decrypted)) {
                tempOrgList = JSON.parse(decrypted);
              }
            }
          } catch (error) {
            console.error('Error loading orgList from localStorage:', error);
            return null;
          }
          if (Array.isArray(tempOrgList)) {
            this.orgList = tempOrgList;
          }
        }
      }

      if (!this.orgList || this.orgList.length === 0) {
        return null;
      }

      // Robust matching: compare as string and number
      const foundOrg = this.orgList.find((org: any) => {
        if (!org.org_id) return false;
        // Compare both as string and number
        return org.org_id == orgId || String(org.org_id) === String(orgId);
      });

      if (foundOrg) {
        const orgName = foundOrg.org_name || foundOrg.name || 'Unknown Organization';
        return orgName;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }
  // Initialize Table Columns (Same structure as Roles Component)
  private initializeTableColumns(): void {
    this.tableColumns = [
      {
        name: 'S.No.',
        dataKey: 'sno',
        position: 'left',
        isSortable: true,
        type: 'sequence',
      },
      {
        name: 'Subject',
        dataKey: 'summary',
        type: 'text',
        position: 'left',
        isSortable: true,
      },
    ];
    if (this.showOrganizationColumn) {
      this.tableColumns.push({
        name: 'Organization',
        dataKey: 'orgName',
        type: 'text',
        position: 'left',
        isSortable: true,
      });
    }
    this.tableColumns.push(
      {
        name: 'Priority',
        dataKey: 'priority',
        type: 'text',
        position: 'left',
        isSortable: true,
      },
      {
        name: 'Status',
        dataKey: 'status',
        type: 'text',
        position: 'left',
        isSortable: true,
      },
      {
        name: 'Created Date',
        dataKey: 'createdDate',
        type: 'date',
        position: 'left',
        isFilterable: true
      },
      {
        name: 'Actions',
        dataKey: 'actions',
        type: 'threeDotActions',
        rowActions: this.rowActionList
      }
    );
  }

  // Initialize Table Actions
  private initializeTableActions(): void {
    this.tableActions = [
      {
        iconName: 'plus',
        iconTooltip: 'Create Ticket',
        name: 'add',
      }
    ];
  }

  // Initialize Filter Attributes
  private initializeFilterAttributes(): void {
    this.filterAttributes = [
      {
        dataKeyName: 'summary',
        name: 'Subject',
        type: 'text'
      },
      {
        dataKeyName: 'priority',
        name: 'Priority',
        type: 'text',
        data: ['Low', 'Medium', 'High', 'Urgent'],
      },
      {
        dataKeyName: 'status',
        name: 'Status',
        type: 'status',
        data: ['Open', 'Pending', 'Resolved', 'Closed'],
      },
      {
        dataKeyName: 'all',
        name: 'All Text',
        type: 'all',
      },
    ];
  }

  // Table Action Handler
  addTicket(): void {
    this.openCreateTicketModal();
  }

  // Row Action Handler (Same as Roles Component)
  rowAction(event: any): void {
    switch (event.rowName) {
      case 'view_ticket':
        this.viewTicket(event.row);
        break;
      case 'edit':
        this.editTicket(event.row);
        break;
      default:
        console.log('Unknown action:', event);
    }
  }

  // Update Status Handler (if needed)
  updateStatus(event: any): void {
    console.log('Update status:', event);
    // Implement status update logic if needed
  }

  // View Ticket
  viewTicket(ticket: any): void {
    this.selectTicket(ticket);
  }

  // Edit Ticket
  editTicket(ticket: any): void {
    this.openCreateTicketModal(ticket);
  }

  // Rest of your existing methods remain the same...
  // (openCreateTicketModal, closeCreateTicketModal, createTicket, submitTicketForm,
  //  fetchTickets, and all filter related methods)
openCreateTicketModal(ticket?: any): void {
  console.log('Opening modal with ticket:', ticket);
  
  // Reset pending files whenever the modal opens
  this.pendingFiles = [];
  
  if (ticket) {
    // Edit mode
    this.isEditingTicket = true;
    this.currentTicketId = ticket.id;
    this.EditOrgId = ticket.organization_id || ticket.orgId || null;
    this.editOrgName = ticket.orgName || '';

    
    // Use the data from the table
    this.ticket = {
      subject: ticket.summary || '',
      description: ticket.description || '',
      email: localStorage.getItem('useremail') || '',
      priority: this.reverseMapPriority(ticket.priority),
      status: this.reverseMapStatus(ticket.status),
       cc_emails: Array.isArray(ticket.cc_emails) ? ticket.cc_emails : ticket.cc_emails? [ticket.cc_emails]: []
    };
    
    console.log('Ticket data set for edit:', {
      subject: this.ticket.subject,
      descriptionLength: this.ticket.description?.length,
      hasDescription: !!this.ticket.description,
      descriptionPreview: this.ticket.description?.substring(0, 200)
    });
    
  } else {
    // Create mode
    this.isEditingTicket = false;
    this.currentTicketId = null;
    this.ticket = {
      subject: '',
      description: '',
      email: localStorage.getItem('useremail') || '',
      priority: 1,
      status: 2,
      cc_emails: [] as string[]
    };
  }

  this.currentCcInput = '';
  this.ccEmailError = '';
  this.isCcTouched = false;

    if (ticket?.id) {
      this.isCreatingTicket = true; 

      this.prepareTicketForEditing(ticket.id).then(() => {
        setTimeout(() => {
          this.initializeQuillEditor();
        }, 300);
      });
      return;
    }
  
  // Open modal FIRST
  this.isCreatingTicket = true;
  
  // Then initialize Quill AFTER Angular has rendered the modal
  setTimeout(() => {
    console.log('Initializing Quill editor...');
    this.initializeQuillEditor();
  }, 300);
}

// Fetch fresh details
private fetchFreshTicketDetails(ticketId: number): void {
  this.api.get(`/tickets/${ticketId}`).subscribe(
    (response: any) => {
      const resBody = response?.body !== undefined ? response.body : response;
      const ticket = resBody?.responseBody || resBody;
      if (ticket && ticket.description && this.quillEditor) {
        setTimeout(() => {
          if (this.quillEditor) {
            this.quillEditor.clipboard.dangerouslyPasteHTML(0, ticket.description);
            this.ticket.description = ticket.description;
          }
        }, 500);
      }
    },
    error => {
      console.error('Error fetching fresh details:', error);
    }
  );
}

// Fetch ticket details for edit
private async fetchTicketDetailsForEdit(ticketId: number): Promise<void> {
  try {
    const response: any = await this.api.get(`/tickets/${ticketId}`).toPromise();
    const resBody = response?.body !== undefined ? response.body : response;
    const ticketData = resBody?.responseBody || resBody;
    
    if (ticketData) {
      this.ticket.subject = ticketData.subject || this.ticket.subject;
      this.ticket.description = ticketData.description || this.ticket.description;
      this.ticket.priority = ticketData.priority || this.ticket.priority;
      this.ticket.status = ticketData.status || this.ticket.status;
      this.currentTicketAttachments = ticketData.attachments || [];
      
      if (this.quillEditor && this.ticket.description) {
        setTimeout(() => {
          if (this.quillEditor) {
            this.quillEditor.clipboard.dangerouslyPasteHTML(0, this.ticket.description);
          }
        }, 500);
      }
    }
  } catch (error) {
    console.error('Error fetching ticket details for edit:', error);
  }
}

  // Use ChangeDetectorRef to refresh view after closing the modal
  closeCreateTicketModal(): void {
    this.isCreatingTicket = false;
    this.isSubmittingTicket = false;
    this.cdr.detectChanges(); // Trigger change detection to refresh the view
  }

  submitTicketForm(): void {
    // Form validation is handled by ngForm; actual submission is done by createTicket() via (click)
  }

  onCcInputChange(): void {
    const value = this.currentCcInput ? this.currentCcInput.trim().toLowerCase() : '';
    if (!value) {
      this.ccEmailError = '';
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      this.ccEmailError = 'Please enter a valid email address';
    } else {
      this.ccEmailError = 'Please click Enter';
    }
  }

  handleCcKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',' || event.key === 'Tab') {
      event.preventDefault();
      this.addCcFromInput();
    }
  }

  handleCcBlur(event: FocusEvent): void {
    this.isCcTouched = true;
    const value = this.currentCcInput ? this.currentCcInput.trim().toLowerCase() : '';
    if (value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        this.ccEmailError = 'Please enter a valid email address';
      } else {
        this.ccEmailError = 'Please click Enter';
      }
    } else {
      this.ccEmailError = '';
    }
  }

  addCcFromInput(): void {
    const value = this.currentCcInput ? this.currentCcInput.trim().toLowerCase() : '';
    if (!value) {
      this.ccEmailError = 'Please enter email';
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      this.ccEmailError = 'Please enter a valid email address';
      this.toastr.error('Invalid email format');
      return;
    }

    if (!this.ticket.cc_emails) {
      this.ticket.cc_emails = [];
    }

    if (this.ticket.cc_emails.includes(value)) {
      this.toastr.warning('Email already added');
      this.currentCcInput = '';
      this.ccEmailError = '';
      return;
    }

    this.ticket.cc_emails.push(value);
    this.currentCcInput = '';
    this.ccEmailError = '';
    this.isCcTouched = false;
  }

  removeCcEmail(index: number): void {
    if (this.ticket.cc_emails) {
      this.ticket.cc_emails.splice(index, 1);
    }
  }

private addNewTicketToTable(ticket: any): void {

  let descriptionHtml = ticket.description || '';

  // Fix image attachments
  if (ticket.attachments && ticket.attachments.length > 0) {
    ticket.attachments.forEach((att: any) => {
      if (att.content_type?.startsWith('image/') && att.attachment_url) {
        descriptionHtml += `
          <p>
            <img src="${att.attachment_url}" 
                 style="max-width:100%;height:auto;" />
          </p>
        `;
      }
    });
  }

  const updatedData = [
    {
      id: ticket.id,
      summary: ticket.subject,
      description: descriptionHtml,
      priority: this.mapPriority(ticket.priority),
      status: this.mapStatus(ticket.status),
      createdDate: ticket.created_at,
      requesterEmail: ticket.requester?.email || 'Unknown',
      orgId: this.orgId,
      orgName: this.orgName || 'N/A'
    },
    ...this.tableDataSource.data
  ].map((t, index) => ({
    ...t,
    sno: index + 1
  }));
  console.log(updatedData,"Updated table data with new ticket");

  // Cache the new ticket so it survives a page refresh before Freshdesk search index catches up
  try {
    const newTicketEntry = {
      id: ticket.id,
      summary: ticket.subject,
      description: descriptionHtml,
      priority: this.mapPriority(ticket.priority),
      status: this.mapStatus(ticket.status),
      createdDate: ticket.created_at,
      requesterEmail: ticket.requester?.email || 'Unknown',
      orgId: this.orgId,
      orgName: this.orgName || 'N/A',
      _savedAt: Date.now()
    };
    const existing = JSON.parse(sessionStorage.getItem('pendingAdminTickets') || '[]');
    existing.push(newTicketEntry);
    sessionStorage.setItem('pendingAdminTickets', JSON.stringify(existing));
  } catch (e) {}

  this.updateTableData(updatedData);
}

private updateTicketInTable(updatedTicket: any): void {

  let descriptionHtml = updatedTicket.description || '';

  // ✅ Handle attachments (same as addNewTicketToTable)
  if (updatedTicket.attachments && updatedTicket.attachments.length > 0) {
    updatedTicket.attachments.forEach((att: any) => {
      if (att.content_type?.startsWith('image/') && att.attachment_url) {
        descriptionHtml += `
          <p>
            <img src="${att.attachment_url}" 
                 style="max-width:100%;height:auto;" />
          </p>
        `;
      }
    });
  }

  const updatedData = this.tableDataSource.data.map((t: any) => {
    if (t.id === updatedTicket.id) {
      return {
        ...t,
        summary: updatedTicket.subject,
        description: descriptionHtml,
        priority: this.mapPriority(updatedTicket.priority),
        status: this.mapStatus(updatedTicket.status),
        createdDate: updatedTicket.created_at,
        requesterEmail: updatedTicket.requester?.email || t.requesterEmail
      };
    }
    return t;
  });

  this.updateTableData(updatedData);
}

createTicket(): void {
  console.log("inside the create ticket")
  const userEmail = localStorage.getItem('useremail');

  if (!userEmail) {
    this.toastr.error('User email not found in localStorage!');
    return;
  }

  if (this.isCcPending) {
    this.ccEmailError = 'Please click Enter';
    this.toastr.warning('Please click Enter to add the CC email before saving.');
    return;
  }
  
  let descriptionContent = this.getQuillEditorContent();

  if (!descriptionContent || descriptionContent.trim() === '') {
    this.toastr.error('Description cannot be empty!');
    return;
  }

  // Strip file placeholder text added during edit preparation (always, not just in FormData path)
  descriptionContent = descriptionContent.replace(/\[(Video|PDF|Word Document|Excel File|Image):.*?\][\s\n]*/gi, '');
  if(this.ticket.cc_emails){
   this.ticket.cc_emails = Array.isArray(this.ticket.cc_emails)
  ? this.ticket.cc_emails
  : [];
  }
  // ✅ Check total size of all pending files (1GB limit) - BEFORE anything else
  const maxSizeGB = 1;
  const maxSizeBytes = maxSizeGB * 1024 * 1024 * 1024;
  
  // Calculate total size of all pending files
  let totalSize = 0;
  this.pendingFiles.forEach(pendingFile => {
    totalSize += pendingFile.file.size;
  });
  
  // Check if total size exceeds 1GB
  if (totalSize > maxSizeBytes) {
    this.toastr.error(`Total file size exceeds ${maxSizeGB}GB. Please remove some files and try again.`);
    return;
  }

  // Check organization info
  if (!this.orgList || this.orgList.length === 0) {
    this.extractAndStoreOrgDetails();
  }
  const currentOrgId = this.EditOrgId ? this.EditOrgId : this.orgId?.toString() || '';
  let currentOrgName = '';
  if (this.orgList && this.orgList.length > 0) {
    const foundOrg = this.orgList.find((org: any) => org.org_id == currentOrgId);
    if (foundOrg) {
      currentOrgName = foundOrg.org_name || 'Unknown';
    } else if (this.EditOrgId) {
      currentOrgName = this.editOrgName ? this.editOrgName : 'Unknown';
    }
  }

  const tags: string[] = [];
  if (currentOrgId) {
    tags.push(`org_id:${currentOrgId}`);
  }
  if (currentOrgName) {
    tags.push(`org_name:${currentOrgName}`);
  }
  const currentEnv = this.getCurrentEnvironment();
  tags.push(`env:${currentEnv}`);

  if (this.externalVideoUrl) {
    descriptionContent += `<br><a href='${this.externalVideoUrl}' target='_blank'>External Video</a>`;
  }

  this.pendingFiles = [];

  const payload: any = {
    description: descriptionContent,
    subject: this.ticket.subject || 'No Subject',
    priority: +this.ticket.priority,
    status: +this.ticket.status,
    tags: tags,
    org_id: currentOrgId ? parseInt(currentOrgId, 10) : null,
    cc_emails: Array.isArray(this.ticket.cc_emails) ? this.ticket.cc_emails : [],
    assigned_to: this.ticket.assigned_to || this.ticket.assignedTo || null
  };

  if (!this.isEditingTicket) {
    payload.email = userEmail;
  }

  this.isSubmittingTicket = true;
  const request$ = (this.isEditingTicket && this.currentTicketId)
    ? this.api.put(`/tickets/${this.currentTicketId}`, { requestBody: payload })
    : this.api.post('/tickets', { requestBody: payload });

  request$.subscribe(
    (response: any) => {
      this.isSubmittingTicket = false;
      const resBody = response?.body !== undefined ? response.body : response;
      const createdTicket = resBody?.responseBody || resBody;
      if (!this.isEditingTicket && !this.currentTicketId && this.ticket.cc_emails?.length) {
        this.getAllService.sendTicketMail(createdTicket).subscribe({
          next: () => console.log('📧 Ticket email sent successfully'),
          error: (err) => console.error('📧 Ticket email failed:', err)
        });
      }
      this.toastr.success(`Ticket ${this.isEditingTicket ? 'updated' : 'created'} successfully!`);
      this.closeCreateTicketModal();
      this.fetchTickets();
    },
    (error: any) => {
      this.isSubmittingTicket = false;
      console.error('Error processing ticket:', error);
      const errorMsg = error?.error?.message || error?.message || 'Error processing ticket. Please try again.';
      this.toastr.error(errorMsg);
    }
  );
}
// Add this helper method to calculate Base64 size
private getBase64Size(base64String: string): number {
  // Remove data URL prefix if present
  const base64 = base64String.includes(',') 
    ? base64String.split(',')[1] 
    : base64String;
  
  // Base64 size formula: (base64_string_length * 3/4) - padding
  const padding = (base64.endsWith('==') ? 2 : (base64.endsWith('=') ? 1 : 0));
  return (base64.length * 3 / 4) - padding;
}

// Usage example:
// const fileSize = this.formatFileSize(file.size); // Returns "2.45 MB"
  // Extract data-URL embedded files from HTML and convert to Blob
private extractEmbeddedFilesFromHtml(html: string): Array<{ name: string; blob: Blob; type: string }> {
  const results: Array<{ name: string; blob: Blob; type: string }> = [];
  if (!html) return results;

  // Match src="data:..." or src='data:...'
  const regex = /src=["'](data:([^"']+))["']/g;
  let match: RegExpExecArray | null;
  let idx = 0;
  while ((match = regex.exec(html)) !== null) {
    const dataUrl = match[1];
    const mime = match[2].split(';')[0] || 'application/octet-stream';
    try {
      const blob = this.dataURLtoBlob(dataUrl);
      const extension = mime.split('/')[1] || 'bin';
      const name = `attachment-${Date.now()}-${idx}.${extension}`;
      results.push({ name, blob, type: mime });
    } catch (e) {
      console.warn('Could not convert data URL to blob:', e);
    }
    idx++;
  }

  return results;
}

// Helper method to convert dataURL to Blob
private dataURLtoBlob(dataurl: string): Blob {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
  // Convert dataURL (full) to Blob
  private base64ToBlob(dataUrl: string): Blob {
    // dataUrl looks like: data:<mime>;base64,<data>
    const parts = dataUrl.split(',');
    if (parts.length < 2) throw new Error('Invalid data URL');
    const meta = parts[0];
    const base64 = parts[1];
    const mimeMatch = meta.match(/data:([^;]+);base64/);
    const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

getCurrentEnvironment(): 'local' | 'dev' | 'qa' | 'uat' | 'prod' {
  if (environment.production) {
    return 'prod';
  }
  const hostname = window.location.hostname.toLowerCase();

  const envMap: { key: string; value: 'local' | 'dev' | 'qa' | 'uat' | 'prod' }[] = [
    { key: 'localhost', value: 'local' },
    { key: '127.0.0.1', value: 'local' },
    { key: 'dev', value: 'dev' },
    { key: 'qa', value: 'qa' },
    { key: 'uat', value: 'uat' },
    { key: 'prod', value: 'prod' }
  ];

  const matchedEnv = envMap.find(env => hostname.includes(env.key));
  return matchedEnv ? matchedEnv.value : 'local';
}

  private isSuperAdminUser(): boolean {
    const role = (localStorage.getItem('role') || '').toLowerCase();
    const ur = (localStorage.getItem('ur') || '').toLowerCase();
    const isSA = localStorage.getItem('isSystemSuperAdmin') === 'true';
    return role === 'admin' || role === 'system super admin' || role === 'sa' || role === 'super admin' || ur === 'sa' || isSA;
  }

  private getFreshdeskHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa(environment.FRESHDESK_API_KEY + ':X'),
      'Accept': 'application/json'
    });
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private async fetchFreshdeskTickets(): Promise<any[]> {
    try {
      const userEmail = localStorage.getItem('useremail');
      const isSuperAdmin = this.isSuperAdminUser();
      const currentEnv = this.getCurrentEnvironment();

      if (!isSuperAdmin && !userEmail) {
        return [];
      }

      let apiUrl = '';
      let isSearchApi = false;

      if (isSuperAdmin) {
        const query = `"tag:'env:${currentEnv}'"`;
        apiUrl = `${environment.FRESHDESK_API_SEARCH}?query=${encodeURIComponent(query)}`;
        isSearchApi = true;
      } else if (userEmail) {
        apiUrl = `${environment.FRESHDESK_API}?email=${encodeURIComponent(userEmail)}&include=description&per_page=100&updated_since=1970-01-01T00:00:00Z`;
      }

      let allTickets: any[] = [];
      let currentPage = 1;
      let hasMore = true;
      let totalCount = 0;

      while (hasMore) {
        const separator = apiUrl.includes('?') ? '&' : '?';
        const requestUrl = `${apiUrl}${separator}page=${currentPage}`;
        try {
          const response: any = await this.http.get(requestUrl, {
            headers: this.getFreshdeskHeaders()
          }).toPromise();

          const tickets = isSearchApi
            ? response?.results || []
            : (Array.isArray(response) ? response : []);

          if (isSearchApi && currentPage === 1) {
            totalCount = response?.total || 0;
          }

          if (tickets && tickets.length > 0) {
            allTickets = [...allTickets, ...tickets];
            currentPage++;

            if (isSearchApi) {
              hasMore = allTickets.length < totalCount && currentPage <= 10;
            } else {
              hasMore = tickets.length === 100;
            }
          } else {
            hasMore = false;
          }
        } catch (err: any) {
          if (err?.status === 429) {
            await this.delay(2000);
            continue;
          }
          console.warn('Could not fetch Freshdesk tickets:', err);
          hasMore = false;
        }
      }

      if (isSearchApi && totalCount > allTickets.length) {
        try {
          let fallbackPage = 1;
          let fallbackHasMore = true;
          const fallbackSeenIds = new Set(allTickets.map(t => t.id));

          while (fallbackHasMore) {
            const fallbackUrl = `${environment.FRESHDESK_API}?include=description&per_page=100&page=${fallbackPage}&updated_since=1970-01-01T00:00:00Z`;
            const fallbackRes: any = await this.http.get(fallbackUrl, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();

            const fallbackTickets = Array.isArray(fallbackRes) ? fallbackRes : [];
            if (fallbackTickets && fallbackTickets.length > 0) {
              for (const ft of fallbackTickets) {
                if (!fallbackSeenIds.has(ft.id)) {
                  fallbackSeenIds.add(ft.id);
                  allTickets.push(ft);
                }
              }
              fallbackPage++;
              fallbackHasMore = fallbackTickets.length === 100;
            } else {
              fallbackHasMore = false;
            }
          }
        } catch (fallbackErr) {
          console.warn('Freshdesk fallback pagination error:', fallbackErr);
        }
      }

      // Filter by environment
      let envFilteredTickets = isSearchApi
        ? allTickets.filter(ticket => !ticket.tags || !ticket.tags.some((t: string) => t.startsWith('env:')) || ticket.tags.includes(`env:${currentEnv}`))
        : allTickets.filter(ticket =>
            ticket.tags && ticket.tags.includes(`env:${currentEnv}`)
          );

      let filteredTickets: any[] = [];
      if (isSuperAdmin) {
        filteredTickets = envFilteredTickets;
      } else {
        filteredTickets = envFilteredTickets.filter(ticket => {
          if (!ticket.tags || !Array.isArray(ticket.tags)) return false;
          const orgTag = ticket.tags.find((tag: string) => tag.startsWith('org_id:'));
          if (!orgTag) return false;
          const ticketOrgId = orgTag.split(':')[1];
          return ticketOrgId === this.orgId?.toString();
        });
      }

      return filteredTickets.map((ticket: any) => {
        let orgIdFromTag = null;
        let orgNameFromTag = null;
        let orgNameFromUserOrgList = null;

        if (ticket.tags && Array.isArray(ticket.tags)) {
          const orgIdTag = ticket.tags.find((tag: string) => tag.startsWith('org_id:'));
          const orgNameTag = ticket.tags.find((tag: string) => tag.startsWith('org_name:'));

          if (orgIdTag) {
            orgIdFromTag = orgIdTag.split(':')[1];
          }
          if (orgNameTag) {
            orgNameFromTag = orgNameTag.split(':')[1];
          }
        }

        if (!orgNameFromTag && orgIdFromTag && this.orgList && this.orgList.length > 0) {
          const foundOrg = this.orgList.find((org: any) => {
            const orgIdInList = org.org_id || org.id || org.organization_id;
            return orgIdInList?.toString() === orgIdFromTag;
          });

          if (foundOrg) {
            orgNameFromUserOrgList = foundOrg.org_name || foundOrg.name || foundOrg.organization_name;
          }
        }

        const finalOrgName = orgNameFromTag || orgNameFromUserOrgList || 'N/A';

        return {
          id: ticket.id,
          isFreshdesk: true,
          summary: ticket.subject,
          description: ticket.description || '',
          priority: typeof ticket.priority === 'number' ? this.mapPriority(ticket.priority) : (ticket.priority || 'Low'),
          status: typeof ticket.status === 'number' ? this.mapStatus(ticket.status) : (ticket.status || 'Open'),
          createdDate: ticket.created_at,
          requesterEmail: ticket.requester?.email || ticket.email || 'Unknown',
          cc_emails: Array.isArray(ticket.cc_emails) ? ticket.cc_emails : (ticket.cc_emails ? [ticket.cc_emails] : []),
          orgId: orgIdFromTag,
          orgName: finalOrgName,
          attachments: ticket.attachments || []
        };
      });
    } catch (e) {
      console.error('Error in fetchFreshdeskTickets:', e);
      return [];
    }
  }

  async fetchTickets(): Promise<void> {
    const userEmail = localStorage.getItem('useremail');
    const isSuperAdmin = this.isSuperAdminUser();
    if (!userEmail && !isSuperAdmin) {
      console.error('User email not found!');
      return;
    }

    this.isLoading = true;

    try {
      if (!this.orgList || this.orgList.length === 0) {
        this.extractAndStoreOrgDetails();
      }

      // 1. Fetch DB tickets (all tickets without artificial limit)
      let dbTickets: any[] = [];
      try {
        const queryParams = this.isSuperAdmin 
          ? '?is_super_admin=true' 
          : (userEmail ? `?email=${encodeURIComponent(userEmail)}` : '');
        const response: any = await this.api.get(`/tickets${queryParams}`).toPromise();
        const resBody = response?.body !== undefined ? response.body : response;
        const ticketData = resBody?.tickets || resBody?.responseBody?.tickets || resBody?.responseBody || (Array.isArray(resBody) ? resBody : []);
        dbTickets = Array.isArray(ticketData) ? ticketData : [];
      } catch (dbErr) {
        console.warn('Error fetching DB tickets:', dbErr);
      }

      const enrichedDbTickets = dbTickets.map((ticket: any) => {
        let tagsArr: string[] = [];
        if (Array.isArray(ticket.tags)) {
          tagsArr = ticket.tags;
        } else if (typeof ticket.tags === 'string' && ticket.tags.trim()) {
          try {
            const parsed = JSON.parse(ticket.tags);
            if (Array.isArray(parsed)) {
              tagsArr = parsed;
            } else {
              tagsArr = [ticket.tags];
            }
          } catch {
            tagsArr = ticket.tags.split(',').map((s: string) => s.trim().replace(/^["'\[\]]+|["'\[\]]+$/g, ''));
          }
        }

        let orgIdFromTag: string | null = null;
        let orgNameFromTag: string | null = null;

        if (tagsArr && tagsArr.length > 0) {
          const orgIdTag = tagsArr.find((t: string) => typeof t === 'string' && t.toLowerCase().startsWith('org_id:'));
          const orgNameTag = tagsArr.find((t: string) => typeof t === 'string' && t.toLowerCase().startsWith('org_name:'));

          if (orgIdTag) {
            orgIdFromTag = orgIdTag.substring(orgIdTag.indexOf(':') + 1).trim();
          }
          if (orgNameTag) {
            orgNameFromTag = orgNameTag.substring(orgNameTag.indexOf(':') + 1).trim();
          }
        }

        let orgNameFromList: string | null = null;
        const effectiveOrgId = ticket.org_id || orgIdFromTag;
        if (effectiveOrgId && this.orgList && this.orgList.length > 0) {
          const foundOrg = this.orgList.find((org: any) => {
            const oId = org.org_id || org.id || org.organization_id;
            return oId?.toString() === effectiveOrgId?.toString();
          });
          if (foundOrg) {
            orgNameFromList = foundOrg.org_name || foundOrg.name || foundOrg.organization_name;
          }
        }

        const finalOrgName = orgNameFromTag || ticket.org_name || ticket.orgName || orgNameFromList || 'Certiplate';
        const finalOrgId = ticket.org_id || orgIdFromTag || null;

        return {
          id: ticket.id,
          isFreshdesk: false,
          summary: ticket.subject,
          description: ticket.description || '',
          priority: typeof ticket.priority === 'number' ? this.mapPriority(ticket.priority) : (ticket.priority || 'Low'),
          status: typeof ticket.status === 'number' ? this.mapStatus(ticket.status) : (ticket.status || 'Open'),
          assigned_to: ticket.assigned_to || null,
          assignedTo: ticket.assigned_to || null,
          createdDate: ticket.created_at,
          requesterEmail: ticket.email || 'Unknown',
          cc_emails: Array.isArray(ticket.cc_emails) ? ticket.cc_emails : (ticket.cc_emails ? [ticket.cc_emails] : []),
          orgId: finalOrgId,
          orgName: finalOrgName,
          tags: tagsArr,
          attachments: ticket.attachments || []
        };
      });

      // 2. Fetch Freshdesk tickets
      let freshdeskTickets: any[] = [];
      try {
        freshdeskTickets = await this.fetchFreshdeskTickets();
      } catch (fErr) {
        console.warn('Could not fetch Freshdesk tickets:', fErr);
      }

      // 3. Combine both lists (avoiding ID collisions with DB tickets)
      const dbTicketIds = new Set(enrichedDbTickets.map(t => String(t.id)));
      const filteredFreshdeskTickets = freshdeskTickets.filter(ft => !dbTicketIds.has(String(ft.id)));

      const allCombinedTickets = [...enrichedDbTickets, ...filteredFreshdeskTickets];

      // Sort newest first
      allCombinedTickets.sort((a, b) => {
        const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
        const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;
        return dateB - dateA;
      });

      // Assign sequential S.No.
      const finalTickets = allCombinedTickets.map((t, idx) => ({
        ...t,
        sno: idx + 1
      }));

      this.updateTableData(finalTickets);
    } catch (error) {
      console.error('Ticket fetch error:', error);
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }
  private updateTableData(tickets: any[]): void {
    this.allCustomerCountsData = tickets;
    this.tableDataSource.data = tickets;
    this.originalDataSource = [...tickets];
    this.isLoading = false;
    
    // If route has an ID parameter, select that ticket
    const currentId = this.activatedRoute.snapshot.params['id'];
    if (currentId && !this.selectedTicket) {
      this.loadAndSelectTicketById(+currentId);
    }
    
    this.cdr.detectChanges();
  }

  // Your existing helper methods for mapping...
  mapPriority(priority: number | string): string {
    const num = +priority;
    const priorityMap: { [key: number]: string } = {
      1: 'Low',
      2: 'Medium',
      3: 'High',
      4: 'Urgent',
    };
    return priorityMap[num] || (typeof priority === 'string' && priority ? priority : 'Low');
  }

  mapStatus(status: number | string): string {
    const num = +status;
    switch (num) {
      case 2: return 'Open';
      case 3: return 'Pending';
      case 4: return 'Resolved';
      case 5: return 'Closed';
      default: return typeof status === 'string' && status ? status : 'Open';
    }
  }

  reverseMapPriority(priority: string | number): number {
    const lower = String(priority).toLowerCase();
    if (lower === 'low' || lower === '1') return 1;
    if (lower === 'medium' || lower === '2') return 2;
    if (lower === 'high' || lower === '3') return 3;
    if (lower === 'urgent' || lower === '4') return 4;
    return 1;
  }

  reverseMapStatus(status: string | number): number {
    const lower = String(status).toLowerCase();
    if (lower === 'open' || lower === '2') return 2;
    if (lower === 'pending' || lower === '3') return 3;
    if (lower === 'resolved' || lower === '4') return 4;
    if (lower === 'closed' || lower === '5') return 5;
    return 2;
  }

  // Your existing filter methods...
  toggleDropdown(filter: string) {
    this.selectedFilter = this.selectedFilter === filter ? null : filter;
    this.searchQuery = '';
    this.selectedOption = '';
  }

  clearFilters() {
    this.selectedOptions = {
      "Status": [],
      "Priority": []
    };
    this.searchQuery = '';
    this.exactDate = '';
    this.startDate = '';
    this.endDate = '';
    this.dateFilterActive = false;
    this.selectedFilters = [];
    this.tableDataSource.data = [...this.originalDataSource];
    this.updateFilterCount();
  }

  applyFilters() {
    let filteredData = [...this.originalDataSource];

    // Apply Status filter
    if (this.selectedOptions["Status"]?.length) {
      filteredData = filteredData.filter(item =>
        this.selectedOptions["Status"].includes(item.status)
      );
    }

    // Apply Priority filter
    if (this.selectedOptions["Priority"]?.length) {
      filteredData = filteredData.filter(item =>
        this.selectedOptions["Priority"].includes(item.priority)
      );
    }

    // Apply Created Date filter
    if (this.selectedFilter === "Created Date") {
      if (this.dateFilterType === 'exact' && this.exactDate) {
        const exactDateObj = this.parseCustomDate(this.exactDate);
        if (exactDateObj) {
          filteredData = filteredData.filter(item => {
            const itemDate = new Date(item.createdDate);
            return (
              itemDate.getFullYear() === exactDateObj.getFullYear() &&
              itemDate.getMonth() === exactDateObj.getMonth() &&
              itemDate.getDate() === exactDateObj.getDate()
            );
          });
          this.dateFilterActive = true;

          const existingFilter = this.selectedFilters.find(f => f.key === "Created Date (Exact)");
          if (existingFilter) {
            existingFilter.value = this.exactDate;
          } else {
            this.selectedFilters.push({
              key: "Created Date (Exact)",
              value: this.exactDate
            });
          }
        }
      } else if (this.dateFilterType === 'range' && this.startDate && this.endDate) {
        const startDateObj = this.parseCustomDate(this.startDate);
        const endDateObj = this.parseCustomDate(this.endDate);

        if (startDateObj && endDateObj) {
          filteredData = filteredData.filter(item => {
            const itemDate = new Date(item.createdDate);
            return itemDate >= startDateObj && itemDate <= endDateObj;
          });
          this.dateFilterActive = true;

          const existingFilter = this.selectedFilters.find(f => f.key === "Created Date (Range)");
          if (existingFilter) {
            existingFilter.value = `${this.startDate} to ${this.endDate}`;
          } else {
            this.selectedFilters.push({
              key: "Created Date (Range)",
              value: `${this.startDate} to ${this.endDate}`
            });
          }
        }
      }
    }

    // Apply All Text filter
    if (this.selectedFilter === "All Text" && this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      filteredData = filteredData.filter(item =>
        ["summary", "priority", "status"].some(key =>
          item[key]?.toLowerCase().includes(query)
        )
      );
      if (!this.selectedFilters.some(f => f.key === "All Text" && f.value === this.searchQuery)) {
        this.selectedFilters.push({ key: "All Text", value: this.searchQuery });
      }
    }

    this.tableDataSource.data = filteredData;
    this.filterCount = this.getSelectedOptionsCount();
  }

  removeFilterTag(filterToRemove: { key: string; value: string }) {
    if (filterToRemove.key === "Status" || filterToRemove.key === "Priority") {
      this.selectedOptions[filterToRemove.key] = this.selectedOptions[filterToRemove.key]
        .filter(item => item !== filterToRemove.value);
    }

    if (filterToRemove.key.includes("Created Date")) {
      if (filterToRemove.key === "Created Date (Exact)") {
        this.exactDate = '';
      } else if (filterToRemove.key === "Created Date (Range)") {
        this.startDate = '';
        this.endDate = '';
      }
      this.dateFilterActive = false;
    }

    this.selectedFilters = this.selectedFilters.filter(filter =>
      !(filter.key === filterToRemove.key && filter.value === filterToRemove.value)
    );

    this.applyFilters();
  }

  onCheckboxChange(option: string, event: any) {
    const filterType = this.selectedFilter as string;
    if (event.target.checked) {
      if (!this.selectedOptions[filterType].includes(option)) {
        this.selectedOptions[filterType].push(option);
        this.selectedFilters.push({ key: filterType, value: option });
      }
    } else {
      this.selectedOptions[filterType] = this.selectedOptions[filterType].filter(item => item !== option);
      this.selectedFilters = this.selectedFilters.filter(item => item.value !== option);
    }
    this.filterCount = this.selectedFilters.length;
  }

  getFilteredOptions(): string[] {
    if (!this.selectedFilter || !this.filterOptions[this.selectedFilter]) {
      return [];
    }

    if (!this.searchQuery) {
      return this.filterOptions[this.selectedFilter];
    }

    return this.filterOptions[this.selectedFilter].filter(option =>
      option.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

  getSelectedOptionsCount(): number {
    let count = 0;
    for (const key in this.selectedOptions) {
      count += this.selectedOptions[key].length;
    }
    return count;
  }

  updateFilterCount() {
    this.filterCount = this.selectedOptions["Status"].length +
      this.selectedOptions["Priority"].length +
      (this.dateFilterActive ? 1 : 0) +
      (this.searchQuery.trim() && this.selectedFilter === "All Text" ? 1 : 0);
  }

  resetDateInputs() {
    this.exactDate = '';
    this.startDate = '';
    this.endDate = '';
  }

  private parseCustomDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = this.getMonthNumber(parts[1]);
      const year = parseInt(parts[2], 10);

      if (!isNaN(day) && month !== -1 && !isNaN(year)) {
        return new Date(year, month, day);
      }
    }

    const parsedDate = new Date(dateStr);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  private getMonthNumber(monthStr: string): number {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthIndex = months.findIndex(m =>
      m.toLowerCase() === monthStr.toLowerCase().substr(0, 3));
    return monthIndex;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (
      this.showfilterdivbox &&
      this.filterBox &&
      !this.filterBox.nativeElement.contains(event.target) &&
      !this.filterButton.nativeElement.contains(event.target)
    ) {
      this.showfilterdivbox = false;
    }
  }

  Filterapply() {
    this.showfilterdivbox = !this.showfilterdivbox;
  }

  private rebuildDescriptionForEdit(
    html: string,
    attachments: any[]
  ): string {
    if (!attachments || attachments.length === 0) return html || '';

    const hasPlaceholders = /\[(Video|Image|PDF|Excel|Word)/i.test(html);
    const hasBrokenImg = /<img(\s*?)>/i.test(html);

    if (hasPlaceholders && !hasBrokenImg) {
      return html || '';
    }

    let rebuilt = html || '';

    const brokenImgMatches = rebuilt.match(/<img(\s[^>]*)?>(?![^<]*src\s*=\s*["'][^"']+["'])/gi) || [];
    const brokenImgCount = brokenImgMatches.filter(tag => !(/src\s*=\s*["'][^"']+["']/.test(tag))).length;
    let brokenImgsAccountedFor = 0;

    attachments.forEach(att => {
      const name = att.name || 'file';

      if (rebuilt.includes(name) || (att.attachment_url && rebuilt.includes(att.attachment_url))) return;

      if (att.content_type?.startsWith('image/')) {
        if (brokenImgsAccountedFor < brokenImgCount) {
          brokenImgsAccountedFor++;
          return;
        }
        rebuilt += `<p><img src="${att.attachment_url}" style="max-width:100%;height:auto;" /></p>`;
      } 
      else if (att.content_type?.startsWith('video/')) {
        rebuilt += `<p>[Video: ${name}]</p>`;
      } 
      else if (att.content_type?.includes('pdf')) {
        rebuilt += `<p>[PDF: ${name}]</p>`;
      } 
      else if (
        att.content_type?.includes('excel') ||
        name.endsWith('.xls') ||
        name.endsWith('.xlsx')
      ) {
        rebuilt += `<p>[Excel File: ${name}]</p>`;
      } 
      else if (
        att.content_type?.includes('word') ||
        name.endsWith('.doc') ||
        name.endsWith('.docx')
      ) {
        rebuilt += `<p>[Word Document: ${name}]</p>`;
      } 
      else {
        rebuilt += `<p>[File: ${name}]</p>`;
      }
    });

    return rebuilt;
  }

  // Edit Mode Properties
  private async prepareTicketForEditing(ticketId: number): Promise<void> {
    try {
      let ticketResp: any = null;

      // 1. Try DB backend
      try {
        const response: any = await this.api.get(`/tickets/${ticketId}`).toPromise();
        const resBody = response?.body !== undefined ? response.body : response;
        ticketResp = resBody?.responseBody || resBody;
      } catch (dbErr) {
        console.log('Ticket not in DB backend, trying Freshdesk...');
      }

      // 2. If not found in DB backend, try Freshdesk
      if (!ticketResp || !ticketResp.subject) {
        try {
          const ticketUrl = `${environment.FRESHDESK_API}/${ticketId}`;
          ticketResp = await this.http.get(ticketUrl, { 
            headers: this.getFreshdeskHeaders() 
          }).toPromise();
        } catch (fErr) {
          console.warn('Could not fetch from Freshdesk:', fErr);
        }
      }

      if (!ticketResp) return;

      let descHtml = ticketResp.description || this.ticket.description || '';
      descHtml = this.rebuildDescriptionForEdit(
        descHtml,
        ticketResp.attachments || []
      );

      const attachments = ticketResp.attachments || [];

      if (descHtml && attachments.length > 0) {
        descHtml = this.repairMissingImageSrc(descHtml, attachments);
      }

      this.ticket.description = descHtml;
      this.ticket.subject = ticketResp.subject || this.ticket.subject || '';
      this.ticket.priority = typeof ticketResp.priority === 'string' ? this.reverseMapPriority(ticketResp.priority) : (ticketResp.priority || 1);
      this.ticket.status = typeof ticketResp.status === 'string' ? this.reverseMapStatus(ticketResp.status) : (ticketResp.status || 2);

      if (ticketResp.cc_emails) {
        this.ticket.cc_emails = Array.isArray(ticketResp.cc_emails)
          ? ticketResp.cc_emails
          : [ticketResp.cc_emails];
      }

      this.currentTicketAttachments = attachments;
      const requesterEmail = ticketResp.requester?.email || ticketResp.email || localStorage.getItem('useremail') || '';
      this.ticket.email = requesterEmail;
    } catch (error) {
      console.error('Error preparing ticket for editing:', error);
      throw error;
    }
  }

// Add this new method to repair missing image sources
private repairMissingImageSrc(html: string, attachments: any[]): string {
  try {
    if (!html) return html;
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const imgs = Array.from(doc.getElementsByTagName('img'));
    
    imgs.forEach(img => {
      const src = img.getAttribute('src');
      
      // If src is empty or is a data URL that might be broken
      if (!src || src.trim() === '' || src.startsWith('data:') && src.length < 100) {
        // Try to find a matching attachment
        const foundAttachment = attachments.find(att => 
          att.content_type && att.content_type.startsWith('image/')
        );
        
        if (foundAttachment && foundAttachment.attachment_url) {
          img.setAttribute('src', foundAttachment.attachment_url);
        }
      }
      
      // Also ensure lazy loading
      if (!img.getAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
      
      // Ensure responsive styling
      const currentStyle = img.getAttribute('style') || '';
      if (!currentStyle.includes('max-width')) {
        img.setAttribute('style', currentStyle + (currentStyle ? ';' : '') + 'max-width:100%;height:auto;');
      }
    });
    
    return doc.body.innerHTML;
  } catch (e) {
    console.error('Error repairing HTML:', e);
    return html;
  }
}

  // ============================================================
  // FRESHDESK SUPER ADMIN UI METHODS
  // ============================================================

  get filteredTicketsList(): any[] {
    let list = this.allCustomerCountsData || [];

    // 1. Top Quick Search
    if (!this.showBulkAssignModal && !this.showDeleteConfirmModal && this.ticketListSearchQuery && this.ticketListSearchQuery.trim()) {
      const q = this.ticketListSearchQuery.trim().toLowerCase();
      list = list.filter(t => 
        (t.summary && t.summary.toLowerCase().includes(q)) ||
        (t.id && String(t.id).includes(q)) ||
        (t.requesterEmail && t.requesterEmail.toLowerCase().includes(q)) ||
        (t.assigned_to && t.assigned_to.toLowerCase().includes(q)) ||
        (t.assignedTo && t.assignedTo.toLowerCase().includes(q)) ||
        (t.orgName && t.orgName.toLowerCase().includes(q)) ||
        (t.description && t.description.toLowerCase().includes(q))
      );
    }

    // 2. Subject Filter
    if (this.appliedFilters.subjectValue && this.appliedFilters.subjectValue.trim()) {
      const val = this.appliedFilters.subjectValue.trim().toLowerCase();
      if (this.appliedFilters.subjectOption === 'is') {
        list = list.filter(t => (t.summary || '').toLowerCase() === val);
      } else {
        list = list.filter(t => (t.summary || '').toLowerCase().includes(val));
      }
    }

    // 3. Priority Filter
    if (this.appliedFilters.priorities && this.appliedFilters.priorities.length > 0) {
      list = list.filter(t => 
        this.appliedFilters.priorities.some(p => (t.priority || '').toLowerCase() === p.toLowerCase())
      );
    }

    // 4. Status Filter
    if (this.appliedFilters.statuses && this.appliedFilters.statuses.length > 0) {
      list = list.filter(t => 
        this.appliedFilters.statuses.some(s => (t.status || '').toLowerCase() === s.toLowerCase())
      );
    }

    // 5. Description Filter
    if (this.appliedFilters.descriptionValue && this.appliedFilters.descriptionValue.trim()) {
      const val = this.appliedFilters.descriptionValue.trim().toLowerCase();
      if (this.appliedFilters.descriptionOption === 'is') {
        list = list.filter(t => (t.description || '').toLowerCase() === val);
      } else {
        list = list.filter(t => (t.description || '').toLowerCase().includes(val));
      }
    }

    // 6. Requester Email Filter
    if (this.appliedFilters.requesterEmailValue && this.appliedFilters.requesterEmailValue.trim()) {
      const val = this.appliedFilters.requesterEmailValue.trim().toLowerCase();
      if (this.appliedFilters.requesterEmailOption === 'is') {
        list = list.filter(t => (t.requesterEmail || '').toLowerCase() === val);
      } else {
        list = list.filter(t => (t.requesterEmail || '').toLowerCase().includes(val));
      }
    }

    // 7. Organization Filter
    if (this.appliedFilters.orgName) {
      list = list.filter(t => 
        String(t.orgId) === String(this.appliedFilters.orgName) || 
        (t.orgName && t.orgName.toLowerCase() === this.appliedFilters.orgName.toLowerCase())
      );
    }

    // 8. Created Date Filter
    if (this.appliedFilters.createdDateStart) {
      const startDate = new Date(this.appliedFilters.createdDateStart);
      startDate.setHours(0, 0, 0, 0);
      if (this.appliedFilters.createdDateOption === 'is') {
        const endDate = new Date(this.appliedFilters.createdDateStart);
        endDate.setHours(23, 59, 59, 999);
        list = list.filter(t => {
          if (!t.createdDate) return false;
          const d = new Date(t.createdDate);
          return d >= startDate && d <= endDate;
        });
      } else if (this.appliedFilters.createdDateOption === 'between' && this.appliedFilters.createdDateEnd) {
        const endDate = new Date(this.appliedFilters.createdDateEnd);
        endDate.setHours(23, 59, 59, 999);
        list = list.filter(t => {
          if (!t.createdDate) return false;
          const d = new Date(t.createdDate);
          return d >= startDate && d <= endDate;
        });
      }
    }

    // 9. Apply Sorting (Date created, Due by time, Last modified, Priority, Status | Asc / Desc)
    list = [...list].sort((a, b) => {
      let comparison = 0;
      switch (this.sortByField) {
        case 'created_at': {
          const dateA = a.createdDate ? new Date(a.createdDate).getTime() : 0;
          const dateB = b.createdDate ? new Date(b.createdDate).getTime() : 0;
          comparison = dateA - dateB;
          break;
        }
        case 'due_by': {
          const dateA = a.due_by ? new Date(a.due_by).getTime() : (a.createdDate ? new Date(a.createdDate).getTime() + 86400000 : 0);
          const dateB = b.due_by ? new Date(b.due_by).getTime() : (b.createdDate ? new Date(b.createdDate).getTime() + 86400000 : 0);
          comparison = dateA - dateB;
          break;
        }
        case 'updated_at': {
          const dateA = a.updated_at || a.createdDate ? new Date(a.updated_at || a.createdDate).getTime() : 0;
          const dateB = b.updated_at || b.createdDate ? new Date(b.updated_at || b.createdDate).getTime() : 0;
          comparison = dateA - dateB;
          break;
        }
        case 'priority': {
          const pOrder: { [key: string]: number } = { 'low': 1, 'medium': 2, 'high': 3, 'urgent': 4 };
          const pA = pOrder[(a.priority || '').toLowerCase()] || 0;
          const pB = pOrder[(b.priority || '').toLowerCase()] || 0;
          comparison = pA - pB;
          break;
        }
        case 'status': {
          const sA = (a.status || '').toLowerCase();
          const sB = (b.status || '').toLowerCase();
          comparison = sA.localeCompare(sB);
          break;
        }
        default:
          comparison = 0;
      }
      return this.sortOrder === 'desc' ? -comparison : comparison;
    });

    return list;
  }

  // Sorting control methods (Freshdesk mockup)
  toggleSortDropdown(): void {
    this.showSortDropdown = !this.showSortDropdown;
  }

  setSortBy(field: 'created_at' | 'due_by' | 'updated_at' | 'priority' | 'status'): void {
    this.sortByField = field;
    this.showSortDropdown = false;
    this.currentPage = 1;
  }

  setSortOrder(order: 'asc' | 'desc'): void {
    this.sortOrder = order;
    this.showSortDropdown = false;
    this.currentPage = 1;
  }

  // Pagination getters & methods
  get totalTicketsCount(): number {
    return this.filteredTicketsList.length;
  }

  get totalPages(): number {
    return Math.ceil(this.totalTicketsCount / this.pageSize) || 1;
  }

  get paginationRangeText(): string {
    const total = this.totalTicketsCount;
    if (total === 0) return '0 - 0 of 0';
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = Math.min(this.currentPage * this.pageSize, total);
    return `${start} - ${end} of ${total}`;
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get paginatedTicketsList(): any[] {
    const list = this.filteredTicketsList;
    const start = (this.currentPage - 1) * this.pageSize;
    return list.slice(start, start + this.pageSize);
  }

  onSearchChange(): void {
    if (this.showBulkAssignModal || this.showDeleteConfirmModal) {
      this.ticketListSearchQuery = '';
      return;
    }
    this.currentPage = 1;
  }

  onBulkAssigneeEmailChange(val: string): void {
    this.bulkAssigneeEmail = val;
    this.ticketListSearchQuery = '';
  }

  // Filter Individual Removal Methods
  removeStatusFilter(st: string): void {
    this.appliedFilters.statuses = this.appliedFilters.statuses.filter(s => s !== st);
    this.tempFilters.statuses = [...this.appliedFilters.statuses];
    this.currentPage = 1;
  }

  removePriorityFilter(pr: string): void {
    this.appliedFilters.priorities = this.appliedFilters.priorities.filter(p => p !== pr);
    this.tempFilters.priorities = [...this.appliedFilters.priorities];
    this.currentPage = 1;
  }

  removeSubjectFilter(): void {
    this.appliedFilters.subjectValue = '';
    this.tempFilters.subjectValue = '';
    this.currentPage = 1;
  }

  removeOrgFilter(): void {
    this.appliedFilters.orgName = '';
    this.tempFilters.orgName = '';
    this.currentPage = 1;
  }

  removeEmailFilter(): void {
    this.appliedFilters.requesterEmailValue = '';
    this.tempFilters.requesterEmailValue = '';
    this.currentPage = 1;
  }

  removeDateFilter(): void {
    this.appliedFilters.createdDateStart = '';
    this.appliedFilters.createdDateEnd = '';
    this.tempFilters.createdDateStart = '';
    this.tempFilters.createdDateEnd = '';
    this.currentPage = 1;
  }

  // 2-Column Popup Filter Methods
  toggleFilterPopup(): void {
    this.showFilterPopup = !this.showFilterPopup;
    if (this.showFilterPopup) {
      // Create deep copy of current applied filters for temporary editing
      this.tempFilters = JSON.parse(JSON.stringify(this.appliedFilters));
      if (!this.selectedFilterTab || !this.filterTabs.includes(this.selectedFilterTab)) {
        this.selectedFilterTab = 'Priority';
      }
    }
  }

  closeFilterPopup(): void {
    this.showFilterPopup = false;
  }

  selectFilterTab(tab: string): void {
    this.selectedFilterTab = tab;
  }

  toggleTempPriority(p: string): void {
    const idx = this.tempFilters.priorities.indexOf(p);
    if (idx > -1) {
      this.tempFilters.priorities.splice(idx, 1);
    } else {
      this.tempFilters.priorities.push(p);
    }
  }

  toggleTempStatus(s: string): void {
    const idx = this.tempFilters.statuses.indexOf(s);
    if (idx > -1) {
      this.tempFilters.statuses.splice(idx, 1);
    } else {
      this.tempFilters.statuses.push(s);
    }
  }

  // Computed list of all organizations from both Freshdesk and DB tickets + system org list
  get availableOrganizationsList(): string[] {
    const orgsSet = new Set<string>();

    // 1. From all loaded tickets (both DB and Freshdesk)
    if (this.allCustomerCountsData && Array.isArray(this.allCustomerCountsData)) {
      this.allCustomerCountsData.forEach(t => {
        if (t.orgName && typeof t.orgName === 'string') {
          const trimmed = t.orgName.trim();
          if (trimmed && trimmed !== 'N/A' && trimmed !== 'Unknown') {
            orgsSet.add(trimmed);
          }
        }
      });
    }

    // 2. From orgList (system organizations)
    if (this.orgList && Array.isArray(this.orgList)) {
      this.orgList.forEach((org: any) => {
        const name = org.org_name || org.name || org.organization_name;
        if (name && typeof name === 'string') {
          const trimmed = name.trim();
          if (trimmed && trimmed !== 'N/A' && trimmed !== 'Unknown') {
            orgsSet.add(trimmed);
          }
        }
      });
    }

    return Array.from(orgsSet).sort((a, b) => a.localeCompare(b));
  }

  clearCurrentTabFilter(): void {
    switch (this.selectedFilterTab) {
      case 'Priority':
        this.tempFilters.priorities = [];
        break;
      case 'Status':
        this.tempFilters.statuses = [];
        break;
      case 'Created Date':
        this.tempFilters.createdDateStart = '';
        this.tempFilters.createdDateEnd = '';
        this.tempFilters.createdDateOption = 'is';
        break;
      case 'Organization':
      case 'OrgName':
        this.tempFilters.orgName = '';
        break;
      default:
        break;
    }
  }

  applyFilterPopup(): void {
    this.appliedFilters = JSON.parse(JSON.stringify(this.tempFilters));
    this.currentPage = 1;
    this.showFilterPopup = false;
  }

  resetAllFilters(): void {
    this.appliedFilters = {
      subjectOption: 'contains',
      subjectValue: '',
      priorities: [],
      statuses: [],
      descriptionOption: 'contains',
      descriptionValue: '',
      createdDateOption: 'is',
      createdDateStart: '',
      createdDateEnd: '',
      requesterEmailOption: 'contains',
      requesterEmailValue: '',
      orgName: ''
    };
    this.tempFilters = JSON.parse(JSON.stringify(this.appliedFilters));
    this.ticketListSearchQuery = '';
    this.currentPage = 1;
    this.showFilterPopup = false;
  }

  isFilterTabApplied(tab: string): boolean {
    switch (tab) {
      case 'Priority':
        return this.appliedFilters.priorities.length > 0;
      case 'Status':
        return this.appliedFilters.statuses.length > 0;
      case 'Created Date':
        return !!this.appliedFilters.createdDateStart;
      case 'Organization':
      case 'OrgName':
        return !!this.appliedFilters.orgName;
      default:
        return false;
    }
  }

  get appliedFilterCount(): number {
    let count = 0;
    if (this.appliedFilters.priorities.length > 0) count += this.appliedFilters.priorities.length;
    if (this.appliedFilters.statuses.length > 0) count += this.appliedFilters.statuses.length;
    if (this.appliedFilters.createdDateStart) count++;
    if (this.appliedFilters.orgName) count++;
    return count;
  }

  // SLA & Overdue Dynamic Calculation
  isTicketOverdue(ticket: any): boolean {
    if (!ticket) return false;
    const status = (ticket.status || '').toLowerCase();
    // Resolved and Closed tickets are NEVER overdue
    if (status === 'resolved' || status === 'closed' || status === '4' || status === '5') {
      return false;
    }
    if (!ticket.createdDate) return false;
    const created = new Date(ticket.createdDate).getTime();
    const now = new Date().getTime();
    // 24 hours SLA threshold for demonstration
    const SLA_MS = 24 * 60 * 60 * 1000;
    return (now - created) > SLA_MS;
  }

  getOverdueDuration(ticket: any): string {
    if (!ticket || !ticket.createdDate) return '';
    const status = (ticket.status || '').toLowerCase();
    if (status === 'resolved' || status === 'closed') {
      return `Resolved`;
    }
    const created = new Date(ticket.createdDate).getTime();
    const now = new Date().getTime();
    const SLA_MS = 24 * 60 * 60 * 1000;
    const overdueMs = (now - created) - SLA_MS;
    if (overdueMs <= 0) return 'Within SLA';

    const diffHours = Math.floor(overdueMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    let durationText = '';
    if (diffYears > 0) durationText = `${diffYears} ${diffYears === 1 ? 'year' : 'years'}`;
    else if (diffMonths > 0) durationText = `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'}`;
    else if (diffDays > 0) durationText = `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
    else durationText = `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'}`;

    return `Resolution overdue by ${durationText}`;
  }

  getSlaDetails(ticket: any): { firstResponse: { isOverdue: boolean, text: string, date: string }, resolution: { isOverdue: boolean, text: string, date: string } } {
    if (!ticket || !ticket.createdDate) {
      return {
        firstResponse: { isOverdue: false, text: 'First response due', date: 'N/A' },
        resolution: { isOverdue: false, text: 'Resolution due', date: 'N/A' }
      };
    }
    const created = new Date(ticket.createdDate);
    const firstResponseDue = new Date(created.getTime() + (8 * 60 * 60 * 1000));
    const resolutionDue = new Date(created.getTime() + (24 * 60 * 60 * 1000));
    const now = new Date();
    const isClosedOrResolved = (ticket.status || '').toLowerCase() === 'resolved' || (ticket.status || '').toLowerCase() === 'closed';

    const frOverdue = !isClosedOrResolved && now.getTime() > firstResponseDue.getTime();
    const resOverdue = !isClosedOrResolved && now.getTime() > resolutionDue.getTime();

    const frDiffMs = Math.abs(now.getTime() - firstResponseDue.getTime());
    const resDiffMs = Math.abs(now.getTime() - resolutionDue.getTime());

    const formatDiff = (ms: number) => {
      const days = Math.floor(ms / (1000 * 60 * 60 * 24));
      const months = Math.floor(days / 30);
      if (months > 0) return `${months} ${months === 1 ? 'month' : 'months'}`;
      if (days > 0) return `${days} ${days === 1 ? 'day' : 'days'}`;
      const hours = Math.floor(ms / (1000 * 60 * 60));
      return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
    };

    return {
      firstResponse: {
        isOverdue: frOverdue,
        text: isClosedOrResolved ? 'First response completed' : (frOverdue ? `First response overdue by ${formatDiff(frDiffMs)}` : `First response due in ${formatDiff(frDiffMs)}`),
        date: firstResponseDue.toLocaleString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      },
      resolution: {
        isOverdue: resOverdue,
        text: isClosedOrResolved ? `Resolution marked as ${ticket.status}` : (resOverdue ? `Resolution overdue by ${formatDiff(resDiffMs)}` : `Resolution due in ${formatDiff(resDiffMs)}`),
        date: resolutionDue.toLocaleString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      }
    };
  }

  getAvatarInitial(nameOrEmail: string): string {
    if (!nameOrEmail) return 'U';
    const clean = nameOrEmail.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    return clean.charAt(0).toUpperCase() || 'U';
  }

  getAvatarColor(nameOrEmail: string): string {
    if (!nameOrEmail) return '#4a90e2';
    const colors = [
      '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3',
      '#009688', '#4caf50', '#ff9800', '#ff5722', '#795548',
      '#f44336', '#00bcd4', '#8bc34a', '#ffc107', '#607d8b'
    ];
    let hash = 0;
    for (let i = 0; i < nameOrEmail.length; i++) {
      hash = nameOrEmail.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  }

  getRequesterDisplayName(ticket: any): string {
    if (!ticket) return 'Unknown User';
    if (ticket.requester?.name) return ticket.requester.name;
    if (ticket.requesterName) return ticket.requesterName;
    if (ticket.author_name) return ticket.author_name;
    const email = ticket.requesterEmail || ticket.email || '';
    if (email.includes('@')) {
      const namePart = email.split('@')[0];
      return namePart
        .split(/[._-]/)
        .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
    }
    return email || 'Unknown User';
  }

  getTimeAgo(dateStr: string | Date): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) return 'Just now';
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHours = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffYears > 0) return `${diffYears} ${diffYears === 1 ? 'year' : 'years'} ago`;
    if (diffMonths > 0) return `${diffMonths} ${diffMonths === 1 ? 'month' : 'months'} ago`;
    if (diffDays > 0) return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`;
    if (diffHours > 0) return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    if (diffMin > 0) return `${diffMin} ${diffMin === 1 ? 'minute' : 'minutes'} ago`;
    return 'Just now';
  }

  getShortTimeAgo(dateStr: string | Date): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) return 'now';
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffYears > 0) return `${diffYears}y`;
    if (diffMonths > 0) return `${diffMonths}mo`;
    if (diffDays > 0) return `${diffDays}d`;
    return 'today';
  }

  getPriorityDotColor(priority: string): string {
    switch ((priority || '').toLowerCase()) {
      case 'low': return '#27ae60';
      case 'medium': return '#f39c12';
      case 'high': return '#e67e22';
      case 'urgent': return '#e74c3c';
      default: return '#95a5a6';
    }
  }

  getStatusBadgeClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'open': return 'badge-status-open';
      case 'pending': return 'badge-status-pending';
      case 'resolved': return 'badge-status-resolved';
      case 'closed': return 'badge-status-closed';
      default: return 'badge-status-default';
    }
  }

  async selectTicket(ticket: any): Promise<void> {
    this.selectedTicket = ticket;
    this.selectedTicketStatus = this.reverseMapStatus(ticket.status);
    this.selectedTicketPriority = this.reverseMapPriority(ticket.priority);
    this.ticketReplyText = '';
    this.replyMode = 'reply';
    
    // Navigate URL to /tickets/:id
    this.route.navigate(['/tickets', ticket.id]);
    
    // Load conversations for the ticket
    await this.loadConversationsForTicket(ticket.id);
    this.cdr.detectChanges();
  }

  backToTicketList(): void {
    this.selectedTicket = null;
    this.route.navigate(['/tickets']);
    this.cdr.detectChanges();
  }

  async loadAndSelectTicketById(id: number): Promise<void> {
    if (this.allCustomerCountsData && this.allCustomerCountsData.length > 0) {
      const found = this.allCustomerCountsData.find(t => String(t.id) === String(id));
      if (found) {
        this.selectedTicket = found;
        this.selectedTicketStatus = this.reverseMapStatus(found.status);
        this.selectedTicketPriority = this.reverseMapPriority(found.priority);
        this.cdr.detectChanges();
        return;
      }
    }
    try {
      let rawTicket: any = null;
      try {
        const response: any = await this.api.get(`/tickets/${id}`).toPromise();
        const resBody = response?.body !== undefined ? response.body : response;
        rawTicket = resBody?.ticket || resBody?.responseBody?.ticket || resBody?.responseBody || resBody;
      } catch (backendErr: any) {
        if (!localStorage.getItem('JwtToken') || backendErr?.status === 401) {
          const returnUrl = (this.route.url && this.route.url !== '/' && !this.route.url.includes('/account/')) ? this.route.url : (window.location.pathname + window.location.search);
          this.route.navigate(['/account/login'], { queryParams: { returnUrl } });
          return;
        }
        // Backend not available, try Freshdesk
        const ticketUrl = `${environment.FRESHDESK_API}/${id}`;
        rawTicket = await this.http.get(ticketUrl, {
          headers: this.getFreshdeskHeaders()
        }).toPromise();
        if (rawTicket) {
          rawTicket.isFreshdesk = true;
        }
      }
      if (rawTicket) {
        this.selectedTicket = this.transformBackendTicket(rawTicket);
        if (rawTicket.isFreshdesk) {
          this.selectedTicket.isFreshdesk = true;
        }
        this.selectedTicketStatus = this.reverseMapStatus(this.selectedTicket.status);
        this.selectedTicketPriority = this.reverseMapPriority(this.selectedTicket.priority);
        this.cdr.detectChanges();
      }
    } catch (e) {
      console.warn('Could not load ticket by id directly:', e);
    }
  }
  transformBackendTicket(ticket: any): any {
    if (!ticket) return null;
    let tagsArr: string[] = [];
    if (Array.isArray(ticket.tags)) {
      tagsArr = ticket.tags;
    } else if (typeof ticket.tags === 'string' && ticket.tags.trim()) {
      try {
        const parsed = JSON.parse(ticket.tags);
        tagsArr = Array.isArray(parsed) ? parsed : [ticket.tags];
      } catch {
        tagsArr = ticket.tags.split(',').map((s: string) => s.trim().replace(/^["'\[\]]+|["'\[\]]+$/g, ''));
      }
    }

    let orgIdFromTag: string | null = null;
    let orgNameFromTag: string | null = null;

    if (tagsArr && tagsArr.length > 0) {
      const orgIdTag = tagsArr.find((t: string) => typeof t === 'string' && t.toLowerCase().startsWith('org_id:'));
      const orgNameTag = tagsArr.find((t: string) => typeof t === 'string' && t.toLowerCase().startsWith('org_name:'));
      if (orgIdTag) orgIdFromTag = orgIdTag.substring(orgIdTag.indexOf(':') + 1).trim();
      if (orgNameTag) orgNameFromTag = orgNameTag.substring(orgNameTag.indexOf(':') + 1).trim();
    }

    let orgNameFromList: string | null = null;
    const effectiveOrgId = ticket.org_id || orgIdFromTag;
    if (effectiveOrgId && this.orgList && this.orgList.length > 0) {
      const foundOrg = this.orgList.find((org: any) => {
        const oId = org.org_id || org.id || org.organization_id;
        return oId?.toString() === effectiveOrgId?.toString();
      });
      if (foundOrg) {
        orgNameFromList = foundOrg.org_name || foundOrg.name || foundOrg.organization_name;
      }
    }

    const finalOrgName = orgNameFromTag || ticket.org_name || ticket.orgName || orgNameFromList || 'Certiplate';
    const finalOrgId = ticket.org_id || orgIdFromTag || null;

    return {
      id: ticket.id,
      isFreshdesk: false,
      summary: ticket.subject || ticket.summary || 'No Subject',
      description: ticket.description || '',
      priority: typeof ticket.priority === 'number' ? this.mapPriority(ticket.priority) : (ticket.priority || 'Low'),
      status: typeof ticket.status === 'number' ? this.mapStatus(ticket.status) : (ticket.status || 'Open'),
      assigned_to: ticket.assigned_to || ticket.assignedTo || null,
      assignedTo: ticket.assigned_to || ticket.assignedTo || null,
      createdDate: ticket.created_at || ticket.createdDate || new Date().toISOString(),
      requesterEmail: ticket.email || ticket.requesterEmail || 'Unknown',
      cc_emails: Array.isArray(ticket.cc_emails) ? ticket.cc_emails : (ticket.cc_emails ? [ticket.cc_emails] : []),
      orgId: finalOrgId,
      orgName: finalOrgName,
      tags: tagsArr,
      attachments: ticket.attachments || []
    };
  }

  onTicketUpdated(updatedTicket: any): void {
    if (!updatedTicket) return;
    const found = this.allCustomerCountsData.find(t => t.id === updatedTicket.id);
    if (found) {
      found.status = updatedTicket.status;
      found.priority = updatedTicket.priority;
      found.type = updatedTicket.type;
      found.assigned_to = updatedTicket.assigned_to;
      found.assignedTo = updatedTicket.assigned_to;
    }
    this.cdr.detectChanges();
  }

  get selectedTicketsCount(): number {
    return this.selectedTicketIds.size;
  }

  isTicketSelected(ticket: any): boolean {
    return !!ticket && this.selectedTicketIds.has(ticket.id);
  }

  toggleTicketSelection(ticket: any, event?: Event): void {
    if (event) event.stopPropagation();
    if (!ticket) return;
    if (this.selectedTicketIds.has(ticket.id)) {
      this.selectedTicketIds.delete(ticket.id);
    } else {
      this.selectedTicketIds.add(ticket.id);
    }
    this.cdr.detectChanges();
  }

  get isAllSelected(): boolean {
    const list = this.paginatedTicketsList;
    if (!list || list.length === 0) return false;
    return list.every(t => this.selectedTicketIds.has(t.id));
  }

  get isPartiallySelected(): boolean {
    const list = this.paginatedTicketsList;
    if (!list || list.length === 0) return false;
    const count = list.filter(t => this.selectedTicketIds.has(t.id)).length;
    return count > 0 && count < list.length;
  }

  toggleSelectAll(event: any): void {
    const checked = event.target.checked;
    const list = this.paginatedTicketsList;
    if (checked) {
      list.forEach(t => this.selectedTicketIds.add(t.id));
    } else {
      list.forEach(t => this.selectedTicketIds.delete(t.id));
    }
    this.cdr.detectChanges();
  }

  clearTicketSelection(): void {
    this.selectedTicketIds.clear();
    this.cdr.detectChanges();
  }

  openBulkAssignModal(): void {
    if (this.selectedTicketIds.size === 0) {
      this.toastr.warning('Please select at least one ticket.');
      return;
    }
    this.bulkAssigneeEmail = '';
    this.ticketListSearchQuery = '';
    this.showBulkAssignModal = true;
    this.cdr.detectChanges();
  }

  closeBulkAssignModal(): void {
    this.showBulkAssignModal = false;
    this.bulkAssigneeEmail = '';
    this.cdr.detectChanges();
  }

  async submitBulkAssign(): Promise<void> {
    const email = (this.bulkAssigneeEmail || '').trim();
    if (!email) {
      this.toastr.warning('Please enter an assignee email.');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.toastr.error('Please enter a valid email address.');
      return;
    }

    const ids = Array.from(this.selectedTicketIds);
    this.isBulkUpdating = true;
    try {
      // Update in-memory lists
      ids.forEach(id => {
        const found = this.allCustomerCountsData.find(t => t.id === id);
        if (found) {
          found.assigned_to = email;
          found.assignedTo = email;
        }
      });
      this.tableDataSource.data = [...this.allCustomerCountsData];
      this.originalDataSource = [...this.allCustomerCountsData];

      this.toastr.success(`${ids.length} ticket(s) assigned to ${email}`);
      this.closeBulkAssignModal();
      this.clearTicketSelection();
    } catch (error: any) {
      console.error('Bulk assign error:', error);
      this.toastr.error('Failed to assign tickets');
    } finally {
      this.isBulkUpdating = false;
      this.cdr.detectChanges();
    }
  }

  async bulkCloseSelectedTickets(): Promise<void> {
    const ids = Array.from(this.selectedTicketIds);
    if (ids.length === 0) return;

    this.isBulkUpdating = true;
    try {
      await Promise.all(ids.map(async (id) => {
        const found = this.allCustomerCountsData.find(t => t.id === id);
        if (found && found.isFreshdesk) {
          try {
            await this.http.put(`${environment.FRESHDESK_API}/${id}`, { status: 5 }, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } catch (fErr) {
            console.warn(`Could not close Freshdesk ticket ${id}:`, fErr);
          }
        } else {
          try {
            await this.api.put(`/tickets/${id}`, { requestBody: { status: 5 } }).toPromise();
          } catch (err: any) {
            if (err?.status === 404) {
              await this.http.put(`${environment.FRESHDESK_API}/${id}`, { status: 5 }, {
                headers: this.getFreshdeskHeaders()
              }).toPromise();
            }
          }
        }
      }));

      ids.forEach(id => {
        const found = this.allCustomerCountsData.find(t => t.id === id);
        if (found) {
          found.status = 'Closed';
        }
      });
      this.tableDataSource.data = [...this.allCustomerCountsData];
      this.originalDataSource = [...this.allCustomerCountsData];

      this.toastr.success(`${ids.length} ticket(s) marked as Closed`);
      this.clearTicketSelection();
    } catch (error: any) {
      console.error('Bulk close error:', error);
      this.toastr.error('Failed to close tickets');
    } finally {
      this.isBulkUpdating = false;
      this.cdr.detectChanges();
    }
  }

  openDeleteConfirmModal(): void {
    if (this.selectedTicketIds.size === 0) {
      this.toastr.warning('Please select at least one ticket to delete.');
      return;
    }
    this.showDeleteConfirmModal = true;
    this.cdr.detectChanges();
  }

  closeDeleteConfirmModal(): void {
    this.showDeleteConfirmModal = false;
    this.cdr.detectChanges();
  }

  async confirmBulkDelete(): Promise<void> {
    const ids = Array.from(this.selectedTicketIds);
    if (ids.length === 0) return;

    this.isBulkUpdating = true;
    try {
      await Promise.all(ids.map(async (id) => {
        const found = this.allCustomerCountsData.find(t => t.id === id);
        if (found && found.isFreshdesk) {
          try {
            await this.http.delete(`${environment.FRESHDESK_API}/${id}`, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } catch (fErr) {
            console.warn(`Could not delete Freshdesk ticket ${id}:`, fErr);
          }
        } else {
          try {
            await this.api.delete('/tickets', String(id)).toPromise();
          } catch (err: any) {
            if (err?.status === 404) {
              await this.http.delete(`${environment.FRESHDESK_API}/${id}`, {
                headers: this.getFreshdeskHeaders()
              }).toPromise();
            }
          }
        }
      }));

      // Remove from active list
      const idSet = new Set(ids);
      this.allCustomerCountsData = this.allCustomerCountsData.filter(t => !idSet.has(t.id));
      this.tableDataSource.data = [...this.allCustomerCountsData];
      this.originalDataSource = [...this.allCustomerCountsData];

      this.toastr.success(`${ids.length} ticket(s) deleted successfully`);
      this.clearTicketSelection();
      this.closeDeleteConfirmModal();
    } catch (error: any) {
      console.error('Bulk delete error:', error);
      this.toastr.error('Failed to delete tickets');
    } finally {
      this.isBulkUpdating = false;
      this.cdr.detectChanges();
    }
  }

  bulkDeleteSelectedTickets(): void {
    this.openDeleteConfirmModal();
  }

  async loadConversationsForTicket(ticketId: number): Promise<void> {
    this.isLoadingConversations = true;
    this.ticketConversations = [];
    try {
      // 1. Try DB backend conversations
      try {
        const response: any = await this.api.get(`/tickets/${ticketId}/conversations`).toPromise();
        const resBody = response?.body !== undefined ? response.body : response;
        const list = resBody?.conversations || resBody?.responseBody || resBody;
        if (Array.isArray(list) && list.length > 0) {
          this.ticketConversations = list.map((c: any) => ({
            id: c.id,
            author_name: c.author_name || (c.is_admin ? 'Support Team' : (this.selectedTicket ? this.getRequesterDisplayName(this.selectedTicket) : 'User')),
            body: c.body || c.body_text || '',
            body_text: c.body_text || '',
            created_at: c.created_at,
            is_admin: !!c.is_admin
          }));
        }
      } catch (dbErr) {
        console.log('Conversations not in DB backend, checking Freshdesk...');
      }

      // 2. If empty, fetch from Freshdesk conversations
      if (this.ticketConversations.length === 0) {
        try {
          const freshdeskConvs: any = await this.http.get<any[]>(`${environment.FRESHDESK_API}/${ticketId}/conversations`, {
            headers: this.getFreshdeskHeaders()
          }).toPromise();

          if (Array.isArray(freshdeskConvs) && freshdeskConvs.length > 0) {
            this.ticketConversations = freshdeskConvs
              .filter((c: any) => (c.body || c.body_text) && !c.private)
              .map((c: any) => ({
                id: c.id,
                author_name: c.from_email || (c.user_id ? 'Support Team' : (this.selectedTicket ? this.getRequesterDisplayName(this.selectedTicket) : 'User')),
                body: c.body || c.body_text || '',
                body_text: c.body_text || '',
                created_at: c.created_at || c.updated_at,
                is_admin: !!c.user_id
              }));
          }
        } catch (fErr) {
          console.warn('Could not fetch Freshdesk conversations:', fErr);
        }
      }
    } catch (err) {
      console.error('Error loading conversations:', err);
    } finally {
      this.isLoadingConversations = false;
      this.cdr.detectChanges();
    }
  }

  async sendTicketReply(): Promise<void> {
    if (!this.ticketReplyText || !this.ticketReplyText.trim() || !this.selectedTicket) {
      this.toastr.warning('Please enter a response.');
      return;
    }

    this.isSendingReply = true;
    const authorName = localStorage.getItem('username') || 'System Super Admin';
    const replyText = this.ticketReplyText.trim();
    const isNote = this.replyMode === 'note';

    const payload = {
      requestBody: {
        body: isNote ? `<b>[Private Note] ${authorName}:</b><br/>${replyText}` : `<b>${authorName}:</b><br/>${replyText}`,
        body_text: replyText,
        author_name: authorName,
        is_admin: true
      }
    };

    try {
      await this.api.post(`/tickets/${this.selectedTicket.id}/reply`, payload).toPromise();
      this.toastr.success(isNote ? 'Note added successfully' : 'Reply sent successfully');
      this.ticketReplyText = '';
      await this.loadConversationsForTicket(this.selectedTicket.id);
    } catch (err: any) {
      console.error('Error sending reply:', err);
      this.toastr.error('Failed to send reply');
    } finally {
      this.isSendingReply = false;
      this.cdr.detectChanges();
    }
  }

  async updateTicketProperties(): Promise<void> {
    if (!this.selectedTicket) return;

    this.isUpdatingProperties = true;
    const freshdeskPayload = {
      status: +this.selectedTicketStatus,
      priority: +this.selectedTicketPriority
    };
    const updatePayload = {
      requestBody: freshdeskPayload
    };

    try {
      if (this.selectedTicket.isFreshdesk) {
        await this.http.put(`${environment.FRESHDESK_API}/${this.selectedTicket.id}`, freshdeskPayload, {
          headers: this.getFreshdeskHeaders()
        }).toPromise();
      } else {
        try {
          await this.api.put(`/tickets/${this.selectedTicket.id}`, updatePayload).toPromise();
        } catch (apiErr: any) {
          if (apiErr?.status === 404) {
            await this.http.put(`${environment.FRESHDESK_API}/${this.selectedTicket.id}`, freshdeskPayload, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } else {
            throw apiErr;
          }
        }
      }
      this.toastr.success('Ticket properties updated successfully');
      
      // Update local object
      this.selectedTicket.status = this.mapStatus(+this.selectedTicketStatus);
      this.selectedTicket.priority = this.mapPriority(+this.selectedTicketPriority);

      const found = this.allCustomerCountsData.find(t => t.id === this.selectedTicket.id);
      if (found) {
        found.status = this.selectedTicket.status;
        found.priority = this.selectedTicket.priority;
      }
    } catch (err: any) {
      console.error('Error updating ticket properties:', err);
      this.toastr.error('Failed to update ticket properties');
    } finally {
      this.isUpdatingProperties = false;
      this.cdr.detectChanges();
    }
  }

  // Row Quick-Update Dropdown Handlers (Freshdesk interactive row actions)
  toggleRowPriorityDropdown(ticketId: number, event: Event): void {
    event.stopPropagation();
    this.activeStatusDropdownTicketId = null;
    this.activePriorityDropdownTicketId = this.activePriorityDropdownTicketId === ticketId ? null : ticketId;
  }

  toggleRowStatusDropdown(ticketId: number, event: Event): void {
    event.stopPropagation();
    this.activePriorityDropdownTicketId = null;
    this.activeStatusDropdownTicketId = this.activeStatusDropdownTicketId === ticketId ? null : ticketId;
  }

  closeAllRowDropdowns(): void {
    this.activePriorityDropdownTicketId = null;
    this.activeStatusDropdownTicketId = null;
  }

  async updateRowPriority(ticket: any, priorityStr: string, event: Event): Promise<void> {
    event.stopPropagation();
    this.activePriorityDropdownTicketId = null;
    if (!ticket || ticket.priority === priorityStr) return;

    const priorityNum = this.reverseMapPriority(priorityStr);
    const oldPriority = ticket.priority;
    ticket.priority = priorityStr;

    const updatePayload = {
      requestBody: {
        priority: priorityNum
      }
    };
    const freshdeskPayload = {
      priority: priorityNum
    };

    try {
      if (ticket.isFreshdesk) {
        await this.http.put(`${environment.FRESHDESK_API}/${ticket.id}`, freshdeskPayload, {
          headers: this.getFreshdeskHeaders()
        }).toPromise();
      } else {
        try {
          await this.api.put(`/tickets/${ticket.id}`, updatePayload).toPromise();
        } catch (apiErr: any) {
          if (apiErr?.status === 404) {
            await this.http.put(`${environment.FRESHDESK_API}/${ticket.id}`, freshdeskPayload, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } else {
            throw apiErr;
          }
        }
      }
      this.toastr.success(`Priority updated to ${priorityStr}`);
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error updating row priority:', err);
      ticket.priority = oldPriority;
      this.toastr.error('Failed to update priority');
      this.cdr.detectChanges();
    }
  }

  async updateRowStatus(ticket: any, statusStr: string, event: Event): Promise<void> {
    event.stopPropagation();
    this.activeStatusDropdownTicketId = null;
    if (!ticket || ticket.status === statusStr) return;

    const statusNum = this.reverseMapStatus(statusStr);
    const oldStatus = ticket.status;
    ticket.status = statusStr;

    const updatePayload = {
      requestBody: {
        status: statusNum
      }
    };
    const freshdeskPayload = {
      status: statusNum
    };

    try {
      if (ticket.isFreshdesk) {
        await this.http.put(`${environment.FRESHDESK_API}/${ticket.id}`, freshdeskPayload, {
          headers: this.getFreshdeskHeaders()
        }).toPromise();
      } else {
        try {
          await this.api.put(`/tickets/${ticket.id}`, updatePayload).toPromise();
        } catch (apiErr: any) {
          if (apiErr?.status === 404) {
            await this.http.put(`${environment.FRESHDESK_API}/${ticket.id}`, freshdeskPayload, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } else {
            throw apiErr;
          }
        }
      }
      this.toastr.success(`Status updated to ${statusStr}`);
      this.cdr.detectChanges();
    } catch (err) {
      console.error('Error updating row status:', err);
      ticket.status = oldStatus;
      this.toastr.error('Failed to update status');
      this.cdr.detectChanges();
    }
  }

  async toggleCloseTicket(): Promise<void> {
    if (!this.selectedTicket) return;
    const isCurrentlyClosed = this.selectedTicket.status === 'Closed';
    const newStatus = isCurrentlyClosed ? 2 : 5; // Open or Closed

    const freshdeskPayload = {
      status: newStatus
    };
    const updatePayload = {
      requestBody: freshdeskPayload
    };

    try {
      if (this.selectedTicket.isFreshdesk) {
        await this.http.put(`${environment.FRESHDESK_API}/${this.selectedTicket.id}`, freshdeskPayload, {
          headers: this.getFreshdeskHeaders()
        }).toPromise();
      } else {
        try {
          await this.api.put(`/tickets/${this.selectedTicket.id}`, updatePayload).toPromise();
        } catch (apiErr: any) {
          if (apiErr?.status === 404) {
            await this.http.put(`${environment.FRESHDESK_API}/${this.selectedTicket.id}`, freshdeskPayload, {
              headers: this.getFreshdeskHeaders()
            }).toPromise();
          } else {
            throw apiErr;
          }
        }
      }
      this.selectedTicket.status = this.mapStatus(newStatus);
      this.selectedTicketStatus = newStatus;
      this.toastr.success(`Ticket marked as ${this.selectedTicket.status}`);

      const found = this.allCustomerCountsData.find(t => t.id === this.selectedTicket.id);
      if (found) {
        found.status = this.selectedTicket.status;
      }
    } catch (err) {
      console.error('Error toggling close ticket:', err);
      this.toastr.error('Failed to update ticket status');
    }
  }

  clearFreshdeskFilters(): void {
    this.resetAllFilters();
  }

  exportTicketsCsv(): void {
    const data = this.filteredTicketsList;
    if (!data || data.length === 0) {
      this.toastr.info('No tickets to export');
      return;
    }

    const headers = ['ID', 'Subject', 'Requester Email', 'Organization', 'Priority', 'Status', 'Created Date'];
    const rows = data.map(t => [
      t.id,
      `"${(t.summary || '').replace(/"/g, '""')}"`,
      `"${t.requesterEmail || ''}"`,
      `"${(t.orgName || '').replace(/"/g, '""')}"`,
      `"${t.priority || ''}"`,
      `"${t.status || ''}"`,
      `"${t.createdDate || ''}"`
    ]);

    const csvContent = 'data:text/csv;charset=utf-8,' + [headers.join(','), ...rows.map(e => e.join(','))].join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `tickets_export_${Date.now()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  prepareHtmlForRender(html: string): string {
    if (!html) return '';
    try {
      let processed = html;
      processed = processed
        .replace(/<p([^>]*)>/g, (match, attrs) => {
          if (/style="[^"]*(?:margin-left|text-align)/.test(match)) return match;
          if (/style="/.test(match)) return match.replace(/style="/, 'style="line-height: 1.6;');
          return '<p style="margin: 0.5em 0; line-height: 1.6;">';
        })
        .replace(/<div([^>]*)>/g, (match, attrs) => {
          if (/style="[^"]*(?:margin-left|text-align)/.test(match)) return match;
          if (/style="/.test(match)) return match.replace(/style="/, 'style="line-height: 1.6;');
          return '<div style="margin: 0.5em 0; line-height: 1.6;">';
        });

      return processed;
    } catch (e) {
      return html;
    }
  }

  getSanitizedDescription(html: string): SafeHtml {
    const prepared = this.prepareHtmlForRender(html || '');
    return prepared;
  }
}